// ==== TRACKERS TAB + EDIT TRACKER MODAL ====
// Split from the original single tempdashboard.js (originally lines 10277-12435).
// Loaded as a plain classic <script defer> alongside the other tempdashboard-*.js files --
// they all share one global scope (like separate parts of one big file), so functions and
// top-level let/const declared in any of these files are visible to all the others, as long
// as the <script> tags stay in the same order every one of these files was split in.

  // ---- TEMP DASHBOARD: Trackers tab -- every tracker THIS org has added
  // (via trackerMemberships), independent of any pigeon, with
  // assign/unassign controls. Any number of orgs can independently add the
  // same physical tracker -- "Remove" here only deletes this org's own
  // membership, never affecting what any other org sees.
  //
  // Visual rebuild 2026-09-23 to match the new mockup -- also shared by
  // Statistics' own Tracker Statistics card (trackerStatusOf below is the
  // single source of truth for both, so the two pages can never disagree).
  function trackerStatusOf(regData) {
    const battery = typeof regData.lastVernalBattery === 'number' ? regData.lastVernalBattery : null;
    const seenMs = regData.lastVernalTimestamp || null;
    const isRecent = seenMs && (Date.now() - seenMs) < 48 * 3600000;
    // Only two states, decided by the last report alone -- battery never changes this
    // (low battery is its own "Critical Battery" count, see renderTrackerStats).
    if (!isRecent) return { cls: 'offline', label: 'Calm' };
    return { cls: 'online', label: 'Active' };
  }

  // Summary cards: Total / Active / Calm (same 2-state split as every card's own
  // badge) / Critical Battery (battery below 20% -- separate from status, a tracker
  // can be Active AND Critical Battery) / Tracked Today.
  function renderTrackerStats(allRawIds) {
    if (!document.getElementById('trk-stat-total')) return;
    const ids = allRawIds || (isAdmin ? Object.keys(registry) : Object.keys(myTrackerMemberships));
    const total = ids.length;
    let activeCount = 0, calmCount = 0, criticalCount = 0, trackedToday = 0;
    const todayStart = new Date(); todayStart.setHours(0, 0, 0, 0);
    ids.forEach(rawId => {
      const regData = registry[rawId] || {};
      const cls = trackerStatusOf(regData).cls;
      if (cls === 'online') activeCount++;
      else calmCount++;
      if (typeof regData.lastVernalBattery === 'number' && regData.lastVernalBattery < 20) criticalCount++;
      if (regData.lastVernalTimestamp && regData.lastVernalTimestamp >= todayStart.getTime()) trackedToday++;
    });
    const pct = (n) => total ? Math.round((n / total) * 100) + '%' : '';
    document.getElementById('trk-stat-total').textContent = total;
    document.getElementById('trk-stat-active').textContent = activeCount;
    document.getElementById('trk-stat-active-pct').textContent = pct(activeCount);
    document.getElementById('trk-stat-calm').textContent = calmCount;
    document.getElementById('trk-stat-calm-pct').textContent = pct(calmCount);
    document.getElementById('trk-stat-critical').textContent = criticalCount;
    document.getElementById('trk-stat-today').textContent = trackedToday;
  }

  function applyTrackerSearch() {
    document.getElementById('trk-loft-reminder').style.display = (currentOrg && currentOrg.homeLoft) ? 'none' : 'block';
    // Admin sees every tracker system-wide, not just their own org's -- same
    // "admin can do whatever" exception applied to Assign Tracker. Regular
    // accounts still only see trackers they've actually added themselves.
    const allRawIds = (isAdmin ? Object.keys(registry) : Object.keys(myTrackerMemberships)).sort();
    const term = document.getElementById('trk-search').value.trim().toLowerCase();
    // MAC-style ids have colons in them, so a literal substring match on
    // "e2bb" would miss "E2:BB:7B:..." even though it's clearly the same
    // thing to a user typing it without separators -- strip colons/dashes/
    // spaces from both sides before comparing, same normalization idea as
    // normalizeMac() on the backend.
    const normalizedTerm = term.replace(/[:\-\s]/g, '');
    const filtered = !term ? allRawIds : allRawIds.filter(rawId => {
      const regData = registry[rawId] || {};
      const displayName = (regData.nickname || regData.mac || rawId || '').toLowerCase();
      const tagId = (regData.mac || rawId || '').toLowerCase();
      const normalizedTagId = tagId.replace(/[:\-\s]/g, '');
      if (displayName.includes(term) || tagId.includes(term) || (normalizedTerm && normalizedTagId.includes(normalizedTerm))) return true;
      // Account matching is admin-only, same reasoning as Pigeon List's
      // search -- regular accounts only ever see their own org's trackers,
      // so matching on account would be a no-op for them.
      if (!isAdmin) return false;
      const owner = orgsBySlug[regData.orgId] || null;
      return ((owner && owner.name) || '').toLowerCase().includes(term) ||
        ((owner && owner.ownerEmail) || '').toLowerCase().includes(term);
    });
    // Status filter (All / Active / Calm -- trackerStatusOf(),
    // the same rule Statistics uses), applied on top of the search match.
    const statusFiltered = trackerStatusFilter === 'all' ? filtered : filtered.filter(rawId => trackerStatusOf(registry[rawId] || {}).cls === (trackerStatusFilter === 'active' ? 'online' : 'offline'));
    // Assignment filter (All / Assigned / Unassigned) -- must match the
    // card's own fallback logic exactly (a stale assignedPigeonId pointing
    // at a since-deleted pigeon shows as "Unassigned" on the card, so it
    // must count as unassigned here too).
    const assignmentFiltered = trackerAssignmentFilter === 'all' ? statusFiltered : statusFiltered.filter(rawId => {
      const assignedPigeonId = (registry[rawId] || {}).assignedPigeonId;
      const isAssigned = !!(assignedPigeonId && allPigeonDocs.find(d => d.id === assignedPigeonId));
      return trackerAssignmentFilter === 'assigned' ? isAssigned : !isAssigned;
    });
    renderTrackersTab(allRawIds, assignmentFiltered);
    renderTrackerStats(allRawIds);
  }

  function renderTrackersTab(allRawIds, filteredRawIds) {
    const grid = document.getElementById('trk-grid');
    if (!grid) return;
    const emptyEl = document.getElementById('trk-empty');
    const countEl = document.getElementById('trk-count');
    const paginationEl = document.getElementById('trk-pagination');

    if (!allRawIds) allRawIds = (isAdmin ? Object.keys(registry) : Object.keys(myTrackerMemberships)).sort();
    if (!filteredRawIds) filteredRawIds = allRawIds;
    countEl.textContent = allRawIds.length ? `(${allRawIds.length})` : '';

    // Regular accounts rarely have more than 20 trackers, so the per-page
    // selector is just clutter for them until they actually have enough to
    // paginate meaningfully -- admins always see it, since they're looking
    // at every account's trackers combined. Doesn't touch the pagination
    // buttons themselves, only whether this one dropdown is shown.
    document.getElementById('trk-per-page-wrap').style.display = (isAdmin || allRawIds.length > 20) ? '' : 'none';

    const footerEl = document.getElementById('trk-footer');
    if (allRawIds.length === 0) {
      emptyEl.style.display = 'block';
      emptyEl.innerHTML = 'No trackers yet. Click "+ Add Tracker" to register one.';
      grid.innerHTML = '';
      paginationEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (filteredRawIds.length === 0) {
      emptyEl.style.display = 'block';
      emptyEl.innerHTML = '<b>No trackers match your search.</b>';
      grid.innerHTML = '';
      paginationEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = '';

    const totalPages = trackersPerPage === Infinity ? 1 : Math.max(1, Math.ceil(filteredRawIds.length / trackersPerPage));
    if (currentTrackerPage > totalPages) currentTrackerPage = totalPages;
    const startIdx = trackersPerPage === Infinity ? 0 : (currentTrackerPage - 1) * trackersPerPage;
    const rawIds = trackersPerPage === Infinity ? filteredRawIds : filteredRawIds.slice(startIdx, startIdx + trackersPerPage);
    const showingEl = document.getElementById('trk-showing');
    if (showingEl) showingEl.textContent = 'Showing ' + (startIdx + 1) + ' to ' + (startIdx + rawIds.length) + ' of ' + filteredRawIds.length + ' tracker' + (filteredRawIds.length !== 1 ? 's' : '');

    renderTrackerPagination(totalPages);
    grid.innerHTML = '';

    rawIds.forEach(rawId => {
      const regData = registry[rawId] || {};
      const assignedPigeon = allPigeonDocs.find(d => d.id === regData.assignedPigeonId);
      const batteryNum = typeof regData.lastVernalBattery === 'number' ? regData.lastVernalBattery : null;
      const battery = batteryNum != null ? batteryNum + '%' : '—';
      const batteryClass = batteryNum == null ? '' : (batteryNum >= 20 ? 'trk-battery-good' : 'trk-battery-low');
      const seen = regData.lastVernalTimestamp ? timeAgo(regData.lastVernalTimestamp) : '—';
      // This card's own dedicated ID badge (the tag-icon line) is a
      // private, own-account-only view -- showing the real MAC there is
      // fine and useful (matches physical hardware). Only the NAME falls
      // back to rawId, never mac -- that's the one that gets reused on a
      // shared flight map, where the MAC must never appear.
      const tagId = regData.mac || rawId;
      const hasLocation = typeof regData.lastLat === 'number' && typeof regData.lastLng === 'number';
      // Pulled from Vernal's own getDeviceList (nickName) right after bind --
      // falls back to the tracker id (never the MAC) if it ever comes back blank.
      const displayName = regData.nickname || rawId;
      // A tracker admin is seeing but this org never added itself has no
      // membership doc to "Remove" -- only the permanent admin Delete makes
      // sense for those, same reasoning as Pigeon List's cross-org handling.
      const isForeignOrg = isAdmin && regData.orgId !== currentOrg.slug;
      // Admin-only (isForeignOrg already implies isAdmin, so regular
      // customers never see this line) -- shows the real owner email
      // instead of the derived "xxx's account" label, since that's what
      // admin actually needs to identify/contact the customer.
      const ownerOrgLabel = isForeignOrg
        ? (orgsBySlug[regData.orgId] ? (orgsBySlug[regData.orgId].ownerEmail || orgsBySlug[regData.orgId].name) : (regData.orgId || 'Unknown account'))
        : null;

      const statusInfo = trackerStatusOf(regData);
      const statusLabel = statusInfo.cls === 'online' ? 'Active' : 'Calm';

      const card = document.createElement('div');
      card.className = 'trk-card';
      card.innerHTML = `
        <div class="trk-card-head">
          <span class="trk-card-name"><i class="fa-solid fa-satellite-dish"></i> ${displayName}</span>
          <div class="trk-card-head-right">
            <span class="stats-mini-status stats-mini-status--${statusInfo.cls}">${statusLabel}</span>
            <button type="button" class="ltc-kebab-btn" aria-label="More actions"><i class="fa-solid fa-ellipsis-vertical"></i></button>
          </div>
        </div>
        <div class="ltc-kebab-menu">
          <div class="ltc-kebab-menu-item trk-assignpigeon-item"><i class="fa-solid fa-dove"></i> Assign Pigeon</div>
          <div class="ltc-kebab-menu-item trk-viewmap-item"><i class="fa-solid fa-map-location-dot"></i> View Map</div>
          <div class="ltc-kebab-menu-item trk-edit-item"><i class="fa-solid fa-pen"></i> Edit</div>
          ${!isForeignOrg ? '<div class="ltc-kebab-menu-divider"></div><div class="ltc-kebab-menu-item danger trk-remove-item"><i class="fa-solid fa-trash"></i> Remove</div>' : ''}
          ${isAdmin ? '<div class="ltc-kebab-menu-divider"></div><div class="ltc-kebab-menu-item danger trk-delete-item"><i class="fa-solid fa-triangle-exclamation"></i> Delete Tracker (admin)</div>' : ''}
        </div>
        ${ownerOrgLabel ? `<div style="font-size:11px;color:var(--text-secondary);margin:-6px 0 10px;">${ownerOrgLabel}</div>` : ''}
        ${assignedPigeon ? `
          <div class="trk-card-pigeon">
            ${pigeonAvatarHtml(assignedPigeon.p)}
            <div class="trk-card-pigeon-text"><b>${assignedPigeon.p.name}</b><span>Ring: ${assignedPigeon.p.ringNumber || '—'}</span></div>
          </div>` : `<div class="trk-card-pigeon trk-card-pigeon--unassigned"><i class="fa-solid fa-dove"></i> Unassigned</div>`}
        <div class="trk-card-row-split">
          <span><i class="fa-solid fa-battery-full ${batteryClass}"></i><b>${battery}</b></span>
          <span><i class="fa-solid fa-clock"></i>Seen ${seen}</span>
        </div>
        <div class="trk-card-row trk-card-addr">
          <i class="fa-solid fa-location-dot"></i>
          <span style="min-width:0;">
            <span class="trk-card-addr-text">${hasLocation ? 'Click to show address' : '—'}</span>
            <span class="trk-card-addr-more">Show more</span>
          </span>
        </div>
        <div class="trk-card-row"><i class="fa-solid fa-arrows-rotate"></i>Checked <span class="trk-checked-text" data-rawid="${rawId}">${fakeCheckedLabel(rawId)}</span></div>
        <div class="trk-card-id"><i class="fa-solid fa-tag"></i> ${tagId}</div>
        <div class="trk-card-actions">
          <button type="button" class="trk-card-btn trk-card-btn--primary trk-viewmap-btn"><i class="fa-solid fa-map-location-dot"></i> View Map</button>
          <button type="button" class="trk-card-btn trk-card-btn--ghost trk-edit-inline-item"><i class="fa-solid fa-pen"></i> Edit</button>
        </div>
      `;
      card.querySelector('.trk-edit-inline-item').onclick = () => openEditTrackerModal(rawId);
      card.querySelector('.trk-viewmap-item').onclick = () => {
        document.querySelectorAll('.ltc-kebab-menu.open').forEach(m => m.classList.remove('open'));
        card.querySelector('.trk-viewmap-btn').click();
      };
      card.querySelector('.trk-assignpigeon-item').onclick = () => {
        document.querySelectorAll('.ltc-kebab-menu.open').forEach(m => m.classList.remove('open'));
        openAssignPigeonModal(rawId);
      };
      if (hasLocation) {
        // Still auto-loads in the background (queued, ~1.1s apart, to
        // respect Nominatim's rate limit) -- fine when this tab only shows
        // a handful of your own trackers, but admin now sees every tracker
        // system-wide, so a card near the end of that queue could sit on
        // the placeholder for a minute or more. The text still SAID "Click
        // to show address" even though nothing was wired to it anymore --
        // now it actually is: clicking jumps the queue for just this one
        // address instead of waiting. reverseGeocode() caches by
        // lat/lng, so if the background queue reaches this same card
        // later, it just hits the cache instead of firing a second lookup.
        const addrEl = card.querySelector('.trk-card-addr-text');
        const moreEl = card.querySelector('.trk-card-addr-more');
        addrEl.style.cursor = 'pointer';
        const setAddr = (text) => {
          addrEl.textContent = text;
          addrEl.classList.remove('expanded');
          moreEl.textContent = 'Show more';
          moreEl.classList.remove('visible');
          // Only show "Show more" once we know the text actually got
          // clamped (needs a frame for the browser to lay it out first).
          requestAnimationFrame(() => {
            if (addrEl.scrollHeight > addrEl.clientHeight + 1) {
              moreEl.classList.add('visible');
              moreEl.onclick = () => {
                const expanded = addrEl.classList.toggle('expanded');
                moreEl.textContent = expanded ? 'Show less' : 'Show more';
              };
            }
          });
        };
        addrEl.onclick = async () => {
          addrEl.textContent = 'Looking up...';
          setAddr(await reverseGeocode(regData.lastLat, regData.lastLng));
        };
        queueReverseGeocode(regData.lastLat, regData.lastLng, addr => setAddr(addr));
      }
      card.querySelector('.trk-viewmap-btn').onclick = () => {
        ntEntryTab = 'trackers';
        activateTab('new-track');
        document.getElementById('nt-tracker-select').value = rawId;
        loadNewTrack();
      };

      const kebabBtn = card.querySelector('.ltc-kebab-btn');
      const kebabMenu = card.querySelector('.ltc-kebab-menu');
      kebabBtn.onclick = (e) => {
        e.stopPropagation();
        const wasOpen = kebabMenu.classList.contains('open');
        document.querySelectorAll('.ltc-kebab-menu.open').forEach(m => m.classList.remove('open'));
        if (!wasOpen) { kebabMenu.classList.add('open'); keepKebabMenuInView(kebabMenu); }
      };
      card.querySelector('.trk-edit-item').onclick = () => {
        kebabMenu.classList.remove('open');
        openEditTrackerModal(rawId);
      };

      // Removes THIS org's membership only -- never touches the shared
      // trackers doc, so any other org that's also added this tracker is
      // completely unaffected.
      const removeItem = card.querySelector('.trk-remove-item');
      if (removeItem) {
        removeItem.onclick = async () => {
          kebabMenu.classList.remove('open');
          if (!(await showConfirmModal('Remove this tracker from your account? It stays in the system -- this just stops it showing here for you.', 'Remove tracker?'))) return;
          try {
            // Tombstone rather than delete -- the tracker doc itself still
            // has this org's legacy orgId field (Remove never touches it,
            // by design, since it's shared), so a hard delete here left
            // nothing behind to tell the backfill routine "this was
            // deliberately removed" vs. "never had a membership," and it
            // would silently recreate the membership on the next reload.
            await db.collection('trackerMemberships').doc(trackerMembershipDocId(rawId)).set({
              removed: true,
              removedAt: firebase.firestore.FieldValue.serverTimestamp()
            }, { merge: true });
          } catch (e) {
            alert('Could not remove: ' + e.message);
          }
        };
      }
      const deleteItem = card.querySelector('.trk-delete-item');
      if (deleteItem) {
        // Admin-only, permanent: deletes the shared tracker doc itself plus
        // every org's membership on it -- unlike Remove above, this DOES
        // affect everyone who's added this tracker.
        deleteItem.onclick = async () => {
          kebabMenu.classList.remove('open');
          if (!(await showConfirmModal(`PERMANENTLY delete tracker ${tagId}? This removes it for every account that's added it, not just yours. This cannot be undone.`, 'Delete tracker?'))) return;
          try {
            const memberSnap = await db.collection('trackerMemberships').where('trackerId', '==', rawId).get();
            const batch = db.batch();
            memberSnap.forEach(doc => batch.delete(doc.ref));
            batch.delete(db.collection('trackers').doc(rawId));
            await batch.commit();
          } catch (e) {
            alert('Could not delete: ' + e.message);
          }
        };
      }
      grid.appendChild(card);
    });
  }

  // ---- Assign Pigeon modal -- reached from a card's ⋮ menu (tracker
  // already known). Kept as its own modal/save-handler rather than reusing
  // the existing pigeon-side openAssignTrackerModal/trk-assign-modal (still
  // used unchanged by Pigeon List's own Assign flow), so this stays a
  // Trackers-page-only change. Writes the exact same two fields every
  // other assign path in the app writes; Unassign Pigeon reuses the
  // existing unassignTracker() helper as-is.
  let assignPigeonTrackerId = null;
  let assignPigeonSelectedId = null;

  function openAssignPigeonModal(trackerId) {
    assignPigeonTrackerId = trackerId;
    const regData = registry[trackerId] || {};
    assignPigeonSelectedId = regData.assignedPigeonId || null;
    document.getElementById('trk-assignpigeon-name').textContent = regData.nickname || trackerId;
    document.getElementById('trk-assignpigeon-search').value = '';
    document.getElementById('trk-assignpigeon-status').textContent = '';
    renderAssignPigeonList('');
    document.getElementById('trk-assignpigeon-modal').classList.add('open');
  }

  function renderAssignPigeonList(term) {
    const wrap = document.getElementById('trk-assignpigeon-list');
    if (!wrap) return;
    const t = (term || '').trim().toLowerCase();
    const own = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug).filter(d => {
      if (!t) return true;
      return (d.p.name || '').toLowerCase().includes(t) || (d.p.ringNumber || '').toLowerCase().includes(t);
    }).sort((a, b) => (a.p.name || '').localeCompare(b.p.name || ''));
    if (!own.length) {
      wrap.innerHTML = '<div class="stats-mini-empty">No pigeons match your search.</div>';
    } else {
      wrap.innerHTML = own.map(d => {
        const sel = d.id === assignPigeonSelectedId;
        const sexIcon = d.p.sex === 'cock' ? '<i class="fa-solid fa-mars trk-pcard-sexicon cock"></i>' : d.p.sex === 'hen' ? '<i class="fa-solid fa-venus trk-pcard-sexicon hen"></i>' : '';
        const assignedElsewhere = d.p.assignedTrackerId && d.p.assignedTrackerId !== assignPigeonTrackerId;
        return `<label class="trn-pcard${sel ? ' selected' : ''}" data-id="${d.id}">
          <input type="radio" name="trk-assignpigeon-radio" ${sel ? 'checked' : ''}>
          ${pigeonAvatarHtml(d.p)}
          <div class="trn-pcard-text"><b>${d.p.name}</b><span>${d.p.ringNumber || '—'}${assignedElsewhere ? ' · on another tracker' : ''}</span></div>
          ${sexIcon}
        </label>`;
      }).join('');
      wrap.querySelectorAll('.trn-pcard').forEach(card => {
        card.onclick = (e) => {
          e.preventDefault();
          assignPigeonSelectedId = card.dataset.id;
          renderAssignPigeonList(document.getElementById('trk-assignpigeon-search').value);
        };
      });
    }
    const currentlyAssigned = (registry[assignPigeonTrackerId] || {}).assignedPigeonId;
    document.getElementById('trk-assignpigeon-unassign').style.display = currentlyAssigned ? '' : 'none';
  }

  const assignPigeonSearchEl = document.getElementById('trk-assignpigeon-search');
  if (assignPigeonSearchEl) assignPigeonSearchEl.oninput = (e) => renderAssignPigeonList(e.target.value);
  const assignPigeonCancelBtn = document.getElementById('trk-assignpigeon-cancel');
  if (assignPigeonCancelBtn) assignPigeonCancelBtn.onclick = () => document.getElementById('trk-assignpigeon-modal').classList.remove('open');
  const assignPigeonUnassignBtn = document.getElementById('trk-assignpigeon-unassign');
  if (assignPigeonUnassignBtn) assignPigeonUnassignBtn.onclick = async () => {
    const currentlyAssigned = (registry[assignPigeonTrackerId] || {}).assignedPigeonId;
    if (!currentlyAssigned) return;
    await unassignTracker(assignPigeonTrackerId, currentlyAssigned);
    document.getElementById('trk-assignpigeon-modal').classList.remove('open');
  };
  const assignPigeonSaveBtn = document.getElementById('trk-assignpigeon-save');
  if (assignPigeonSaveBtn) assignPigeonSaveBtn.onclick = async () => {
    const statusEl = document.getElementById('trk-assignpigeon-status');
    if (!assignPigeonSelectedId) {
      statusEl.textContent = 'Pick a pigeon, or use "Unassign Pigeon" to clear it.';
      statusEl.style.color = '#c0392b';
      return;
    }
    statusEl.textContent = 'Assigning...';
    statusEl.style.color = '#6b7a87';
    try {
      // Same write pattern as every other assign path -- clear the pigeon's
      // OLD tracker link first (if it had one) and the tracker's OLD
      // pigeon link (if this tracker was already on someone else), so
      // nothing ends up pointing both ways at once.
      const pigeon = allPigeonDocs.find(d => d.id === assignPigeonSelectedId);
      const previousTrackerId = pigeon && pigeon.p.assignedTrackerId;
      const previousPigeonId = (registry[assignPigeonTrackerId] || {}).assignedPigeonId;
      if (previousTrackerId && previousTrackerId !== assignPigeonTrackerId) {
        await db.collection('trackers').doc(previousTrackerId).update({ assignedPigeonId: firebase.firestore.FieldValue.delete() });
      }
      if (previousPigeonId && previousPigeonId !== assignPigeonSelectedId) {
        await db.collection('pigeons').doc(previousPigeonId).update({ assignedTrackerId: firebase.firestore.FieldValue.delete() });
      }
      await db.collection('pigeons').doc(assignPigeonSelectedId).update({ assignedTrackerId: assignPigeonTrackerId });
      await db.collection('trackers').doc(assignPigeonTrackerId).update({ assignedPigeonId: assignPigeonSelectedId });
      statusEl.textContent = 'Assigned!';
      statusEl.style.color = '#2e8b57';
      setTimeout(() => document.getElementById('trk-assignpigeon-modal').classList.remove('open'), 500);
    } catch (e) {
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
    }
  };

  function renderTrackerPagination(totalPages) {
    const el = document.getElementById('trk-pagination');
    if (totalPages <= 1) {
      el.innerHTML = '';
      return;
    }
    el.innerHTML = '';

    const prevBtn = document.createElement('button');
    prevBtn.textContent = 'Prev';
    prevBtn.disabled = currentTrackerPage === 1;
    prevBtn.onclick = () => { currentTrackerPage--; applyTrackerSearch(); };
    el.appendChild(prevBtn);

    for (let i = 1; i <= totalPages; i++) {
      const pageBtn = document.createElement('button');
      pageBtn.textContent = i;
      if (i === currentTrackerPage) pageBtn.className = 'active';
      pageBtn.onclick = () => { currentTrackerPage = i; applyTrackerSearch(); };
      el.appendChild(pageBtn);
    }

    const nextBtn = document.createElement('button');
    nextBtn.textContent = 'Next';
    nextBtn.disabled = currentTrackerPage === totalPages;
    nextBtn.onclick = () => { currentTrackerPage++; applyTrackerSearch(); };
    el.appendChild(nextBtn);
  }

  document.getElementById('trk-search').oninput = () => {
    currentTrackerPage = 1; // a new search always starts back on page 1
    applyTrackerSearch();
  };

  document.getElementById('trk-per-page').onchange = (e) => {
    trackersPerPage = e.target.value === 'all' ? Infinity : parseInt(e.target.value, 10);
    currentTrackerPage = 1;
    applyTrackerSearch();
  };

  document.getElementById('trk-status-filter').onchange = (e) => {
    trackerStatusFilter = e.target.value;
    currentTrackerPage = 1;
    applyTrackerSearch();
  };
  document.getElementById('trk-assignment-filter').onchange = (e) => {
    trackerAssignmentFilter = e.target.value;
    currentTrackerPage = 1;
    applyTrackerSearch();
  };
  // Shared by the Trackers page's "+ Add Tracker" button and Home's
  // "Add Tracker" quick action -- one modal, one flow.
  function openAddTrackerModal() {
    document.getElementById('trk-add-mac').value = '';
    document.getElementById('trk-add-status').textContent = '';
    document.getElementById('trk-add-modal').classList.add('open');
  }
  document.getElementById('trk-add-btn').onclick = openAddTrackerModal;
  // "+ Add Tracker" inside the Add/Edit Pigeon dialog: same Add Tracker dialog, opened on top.
  document.getElementById('db-pigeon-add-tracker-btn').onclick = openAddTrackerModal;
  // After a tracker is added from the pigeon dialog, refresh its dropdown (without
  // disturbing what the pigeon is already set to) and pick the new tracker.
  function refreshPigeonTrackerAfterAdd(newRawId) {
    const pigeonModal = document.getElementById('db-pigeon-modal');
    const sel = document.getElementById('db-pigeon-tracker');
    if (!pigeonModal || !sel || !pigeonModal.classList.contains('open')) return;
    const attempt = (triesLeft) => {
      const keep = sel.value, initial = pigeonTrackerInitial;
      populatePigeonTrackerSelect(keep || null);
      pigeonTrackerInitial = initial;
      if (newRawId && [...sel.options].some(o => o.value === newRawId)) { sel.value = newRawId; }
      else if ([...sel.options].some(o => o.value === keep)) { sel.value = keep; }
      if (newRawId && sel.value !== newRawId && triesLeft > 0) setTimeout(() => attempt(triesLeft - 1), 1000);
    };
    setTimeout(() => attempt(3), 900);
  }
  document.getElementById('trk-add-cancel').onclick = () => {
    document.getElementById('trk-add-modal').classList.remove('open');
  };
  document.getElementById('trk-add-save').onclick = async () => {
    const mac = document.getElementById('trk-add-mac').value.trim();
    const statusEl = document.getElementById('trk-add-status');
    if (!mac) {
      statusEl.textContent = 'Enter a MAC address.';
      statusEl.style.color = '#c0392b';
      return;
    }
    statusEl.innerHTML = '<span class="db-spinner"></span> Connecting to Flightpath ....';
    statusEl.style.color = '#6b7a87';
    try {
      const idToken = await auth.currentUser.getIdToken();
      const resp = await fetch('https://us-central1-flightpathlive-24331.cloudfunctions.net/bindDeviceByMac', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
        body: JSON.stringify({ mac, orgId: currentOrg.slug })
      }).then(r => r.json());
      if (resp.ok) {
        // The bind itself is shared/global (one trackers doc per physical
        // device) -- this membership doc is what actually makes it show up
        // on THIS org's Trackers tab. Doc ID is deterministic (rawId + org),
        // so adding an already-added tracker again just overwrites the same
        // membership doc instead of creating a duplicate.
        try {
          await db.collection('trackerMemberships').doc(trackerMembershipDocId(resp.rawId)).set({
            trackerId: resp.rawId,
            orgId: currentOrg.slug,
            addedAt: firebase.firestore.FieldValue.serverTimestamp()
          });
        } catch (e) {
          console.warn('Failed to save tracker membership:', e.message);
        }
        statusEl.textContent = 'Tracker added!';
        statusEl.style.color = '#2e8b57';
        setTimeout(() => document.getElementById('trk-add-modal').classList.remove('open'), 700);
        refreshPigeonTrackerAfterAdd(resp.rawId);
      } else {
        // bindDeviceByMac returns "bind: Device does not exist, lookup: Device
        // does not exist" when Vernal has never heard of this MAC -- swap in
        // a message a customer can actually act on.
        statusEl.textContent = /device does not exist/i.test(resp.message)
          ? 'No tag found with that MAC address. Check it matches the address printed on the tag.'
          : resp.message;
        statusEl.style.color = '#c0392b';
      }
    } catch (e) {
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
    }
  };

  // Assign modal can be opened two ways: from a Pigeon card (pigeon known,
  // pick a tracker) or from a Trackers card (tracker known, pick a pigeon).
  // Only one of the two "known" params is set at a time.
  let assignModalPigeonId = null;
  let assignModalPigeonName = null;
  let assignModalTrackerId = null;

  function openAssignTrackerModal(pigeonId, pigeonName, trackerId) {
    assignModalPigeonId = pigeonId || null;
    assignModalTrackerId = trackerId || null;
    document.getElementById('trk-assign-status').textContent = '';
    const select = document.getElementById('trk-assign-select');
    select.innerHTML = '';

    if (trackerId) {
      // Tracker known -- pick from this org's unassigned pigeons.
      assignModalPigeonName = null;
      document.getElementById('trk-assign-pigeon-name').textContent = (registry[trackerId] && registry[trackerId].nickname) || trackerId;
      const available = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug && !d.p.assignedTrackerId);
      if (available.length === 0) {
        select.innerHTML = '<option value="">No unassigned pigeons</option>';
      } else {
        available.forEach(d => {
          const opt = document.createElement('option');
          opt.value = d.id;
          opt.textContent = d.p.name;
          select.appendChild(opt);
        });
      }
    } else {
      // Pigeon known -- pick a tracker. Regular accounts only see their own
      // org's UNASSIGNED trackers. Admin sees every tracker system-wide,
      // including ones already assigned to another pigeon (admin can
      // reassign a tracker away from its current pigeon) -- labeled with
      // the owning account and, if taken, which pigeon currently has it, so
      // it's clear what's being overridden. trk-assign-save below is what
      // actually clears the old pigeon's link when this happens.
      assignModalPigeonName = pigeonName;
      document.getElementById('trk-assign-pigeon-name').textContent = pigeonName;
      // Regular accounts: gate on the real membership (myTrackerMemberships,
      // which already excludes removed/tombstoned trackers -- see the
      // trk-remove-item handler), not the legacy `orgId` field on the
      // tracker doc itself. That field never gets cleared by Remove since
      // the tracker record is shared, so it would otherwise keep offering
      // a tracker the user just removed as if it were still theirs.
      const available = Object.keys(registry).filter(rawId =>
        isAdmin ? true : (!!myTrackerMemberships[rawId] && !registry[rawId].assignedPigeonId)
      );
      if (available.length === 0) {
        select.innerHTML = '<option value="">No unassigned trackers</option>';
      } else {
        available.forEach(rawId => {
          const opt = document.createElement('option');
          opt.value = rawId;
          const idLabel = rawId;
          const nickname = registry[rawId].nickname;
          const trackerOrgId = registry[rawId].orgId;
          const orgLabel = isAdmin && trackerOrgId !== currentOrg.slug
            ? ' (' + (orgsBySlug[trackerOrgId] ? orgsBySlug[trackerOrgId].name : trackerOrgId) + ')' : '';
          const currentPigeonId = registry[rawId].assignedPigeonId;
          const currentPigeon = currentPigeonId ? allPigeonDocs.find(d => d.id === currentPigeonId) : null;
          const takenLabel = currentPigeonId ? ' -- currently on ' + (currentPigeon ? currentPigeon.p.name : 'another pigeon') : '';
          opt.textContent = (nickname ? idLabel + ' — ' + nickname : idLabel) + orgLabel + takenLabel;
          select.appendChild(opt);
        });
      }
    }
    document.getElementById('trk-assign-modal').classList.add('open');
  }

  document.getElementById('trk-assign-cancel').onclick = () => {
    document.getElementById('trk-assign-modal').classList.remove('open');
  };

  document.getElementById('nt-no-location-close').onclick = () => {
    document.getElementById('nt-no-location-modal').classList.remove('open');
  };

  document.getElementById('trk-assign-save').onclick = async () => {
    const select = document.getElementById('trk-assign-select');
    const statusEl = document.getElementById('trk-assign-status');
    const chosenValue = select.value;
    if (!chosenValue) {
      statusEl.textContent = 'Nothing available to assign.';
      statusEl.style.color = '#c0392b';
      return;
    }
    const pigeonId = assignModalPigeonId || chosenValue;
    const trackerId = assignModalTrackerId || chosenValue;
    statusEl.textContent = 'Assigning...';
    statusEl.style.color = '#6b7a87';
    try {
      // Admin can pick a tracker that's already on a different pigeon --
      // clear that old pigeon's link first so it doesn't keep pointing at
      // a tracker it no longer actually has.
      const previousPigeonId = registry[trackerId] && registry[trackerId].assignedPigeonId;
      if (previousPigeonId && previousPigeonId !== pigeonId) {
        await db.collection('pigeons').doc(previousPigeonId).update({ assignedTrackerId: firebase.firestore.FieldValue.delete() });
      }
      await db.collection('pigeons').doc(pigeonId).update({ assignedTrackerId: trackerId });
      await db.collection('trackers').doc(trackerId).update({ assignedPigeonId: pigeonId });
      statusEl.textContent = 'Assigned!';
      statusEl.style.color = '#2e8b57';
      setTimeout(() => document.getElementById('trk-assign-modal').classList.remove('open'), 500);
    } catch (e) {
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
    }
  };

  async function unassignTracker(trackerId, pigeonId) {
    if (!(await showConfirmModal('Unassign this tracker? Its location history stays as-is, it just stops being linked to this pigeon.', 'Unassign tracker?'))) return;
    try {
      await db.collection('pigeons').doc(pigeonId).update({ assignedTrackerId: firebase.firestore.FieldValue.delete() });
      await db.collection('trackers').doc(trackerId).update({ assignedPigeonId: firebase.firestore.FieldValue.delete() });
    } catch (e) {
      alert('Could not unassign: ' + e.message);
    }
  }

  // ---- EDIT TRACKER MODAL: rename, link/unlink a pigeon, and a private
  // note, in one place -- replaces the separate standalone Assign button on
  // the card. "Name" overrides Vernal's own nickName for display only (no
  // Vernal endpoint lets us actually rename a device). "Notes" lives on
  // THIS org's membership doc, never the shared tracker doc, so it's never
  // visible to another org that's also added the same tracker.
  let editingTrackerRawId = null;

  async function openEditTrackerModal(rawId) {
    editingTrackerRawId = rawId;
    const regData = registry[rawId] || {};
    document.getElementById('trk-edit-name').value = regData.nickname || '';
    document.getElementById('trk-edit-status').textContent = '';

    // Admin editing another org's tracker: the pigeon dropdown must list
    // THAT tracker's own org's pigeons, not the admin's own -- otherwise an
    // already-assigned pigeon from the real owner's account wouldn't even
    // appear in the list, and saving would silently unassign it. allPigeonDocs
    // already holds every org's pigeons for admin (unscoped listener), so
    // this is just picking the right org to filter by.
    const targetOrgId = (isAdmin && regData.orgId && regData.orgId !== currentOrg.slug) ? regData.orgId : currentOrg.slug;
    const select = document.getElementById('trk-edit-pigeon');
    select.innerHTML = '<option value="">None</option>';
    allPigeonDocs
      .filter(d => d.p.orgId === targetOrgId)
      .forEach(d => {
        const opt = document.createElement('option');
        opt.value = d.id;
        opt.textContent = d.p.name;
        select.appendChild(opt);
      });
    select.value = regData.assignedPigeonId || '';

    const membershipDoc = await db.collection('trackerMemberships').doc(trackerMembershipDocId(rawId)).get();
    document.getElementById('trk-edit-notes').value = (membershipDoc.exists && membershipDoc.data().notes) || '';

    document.getElementById('trk-edit-modal').classList.add('open');
  }

  document.getElementById('trk-edit-cancel').onclick = () => {
    document.getElementById('trk-edit-modal').classList.remove('open');
  };

  document.getElementById('trk-edit-save').onclick = async () => {
    const rawId = editingTrackerRawId;
    if (!rawId) return;
    const statusEl = document.getElementById('trk-edit-status');
    const name = document.getElementById('trk-edit-name').value.trim();
    const newPigeonId = document.getElementById('trk-edit-pigeon').value || null;
    const notes = document.getElementById('trk-edit-notes').value;
    const regData = registry[rawId] || {};
    const previousPigeonId = regData.assignedPigeonId || null;

    statusEl.textContent = 'Saving...';
    statusEl.style.color = '#6b7a87';
    try {
      await db.collection('trackers').doc(rawId).set({ nickname: name || null }, { merge: true });

      if (newPigeonId !== previousPigeonId) {
        if (previousPigeonId) {
          await db.collection('pigeons').doc(previousPigeonId).update({ assignedTrackerId: firebase.firestore.FieldValue.delete() });
        }
        if (newPigeonId) {
          // The newly-chosen pigeon might already have had a DIFFERENT
          // tracker linked -- free that one up too, one tracker per pigeon.
          const newPigeonDoc = allPigeonDocs.find(d => d.id === newPigeonId);
          if (newPigeonDoc && newPigeonDoc.p.assignedTrackerId && newPigeonDoc.p.assignedTrackerId !== rawId) {
            await db.collection('trackers').doc(newPigeonDoc.p.assignedTrackerId).update({ assignedPigeonId: firebase.firestore.FieldValue.delete() });
          }
          await db.collection('pigeons').doc(newPigeonId).update({ assignedTrackerId: rawId });
          await db.collection('trackers').doc(rawId).update({ assignedPigeonId: newPigeonId });
        } else {
          await db.collection('trackers').doc(rawId).update({ assignedPigeonId: firebase.firestore.FieldValue.delete() });
        }
      }

      await db.collection('trackerMemberships').doc(trackerMembershipDocId(rawId)).set({ notes }, { merge: true });

      statusEl.textContent = 'Saved!';
      statusEl.style.color = '#2e8b57';
      setTimeout(() => document.getElementById('trk-edit-modal').classList.remove('open'), 500);
    } catch (e) {
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
    }
  };

  // Haversine distance in km -- same formula used elsewhere (filterOutliers),
  // just returning km instead of being folded into a speed check.
  function haversineKm(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // Free OpenStreetMap Nominatim reverse geocoding -- no cost, but rate
  // limited to ~1 request/second, so this is only ever called for one
  // point at a time (the "Last address" stat, or a single history row on
  // demand), never in a loop over every point.
  async function reverseGeocode(lat, lng) {
    const key = lat.toFixed(4) + ',' + lng.toFixed(4);
    if (ntGeocodeCache[key]) return ntGeocodeCache[key];
    try {
      const resp = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=16`, {
        headers: { 'Accept-Language': 'en' }
      }).then(r => r.json());
      const address = resp.display_name || `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
      ntGeocodeCache[key] = address;
      return address;
    } catch (e) {
      return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
    }
  }

  // Lets multiple cards/rows auto-load their address on render (instead of
  // waiting for a click) without breaking Nominatim's ~1 req/sec limit --
  // each call gets appended to one shared chain, so they fire one at a
  // time, spaced out, no matter how many are on screen at once.
  //
  // Cache hits are checked BEFORE joining that chain, not after -- a lot of
  // consecutive history rows share the exact same (or a barely-moved)
  // coordinate, e.g. a tracker sitting still for a while. Without this
  // check, an already-cached row still had to wait its turn behind every
  // slower, real lookup queued ahead of it, even though its own answer was
  // sitting right there the whole time -- it just wasn't allowed to jump
  // the line. Also re-checked once the queue actually reaches this call,
  // in case an identical coordinate queued just before it filled the cache
  // while this one was still waiting -- skips the 1.1s pacing gap too in
  // that case, since no real request happened this turn either.
  let geocodeQueue = Promise.resolve();
  function queueReverseGeocode(lat, lng, onDone) {
    const key = lat.toFixed(4) + ',' + lng.toFixed(4);
    if (ntGeocodeCache[key]) { onDone(ntGeocodeCache[key]); return; }
    geocodeQueue = geocodeQueue.then(async () => {
      const wasCached = !!ntGeocodeCache[key];
      onDone(await reverseGeocode(lat, lng));
      if (!wasCached) await new Promise(r => setTimeout(r, 1100));
    });
  }

  // Persists a resolved address back onto the point's own Firestore
  // "detections" document (a cheap single-field update), so the NEXT time
  // anyone -- any customer, any session, any device -- loads this exact
  // point, it already has its address and never needs to ask Nominatim for
  // it again. Points loaded from Firestore already carry whatever address
  // was saved last time (see the detections onSnapshot handler above) --
  // this only ever calls out to Nominatim for a point that's never been
  // resolved by anyone before.
  function resolvePointAddress(point, onDone) {
    if (point.address) { onDone(point.address); return; }
    queueReverseGeocode(point.lat, point.lng, addr => {
      point.address = addr;
      onDone(addr);
      if (point.id) {
        db.collection('detections').doc(point.id).update({ address: addr }).catch(() => {});
      }
    });
  }

  // "Share / directions" on a point's popup -- same idea as the competitor's
  // share button: hands off a Google Maps directions link to this exact
  // point through the device's own native share sheet (the same one shown
  // for any other app's Share button), rather than building a custom
  // share UI ourselves. Falls back to copying the link for
  // browsers/platforms with no native share sheet at all (most desktop
  // Firefox, mainly).
  async function sharePointLocation(point) {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${point.lat},${point.lng}`;
    if (navigator.share) {
      try {
        await navigator.share({ title: 'Location', url });
      } catch (e) {
        // User closed/cancelled the share sheet -- not an error, nothing to do.
      }
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(url);
      showToast('Directions link copied to clipboard');
    } else {
      window.open(url, '_blank');
    }
  }

  document.getElementById('nt-tracker-select').onchange = () => loadNewTrack();
  document.getElementById('nt-window-select').onchange = (e) => {
    const customRange = document.getElementById('nt-custom-range');
    if (e.target.value === 'custom') {
      customRange.style.display = 'flex';
      if (!document.getElementById('nt-range-to').value) {
        const now = new Date();
        const from = new Date(now.getTime() - 24 * 3600 * 1000);
        const toLocalInput = (d) => {
          d = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
          return d.toISOString().slice(0, 16);
        };
        document.getElementById('nt-range-from').value = toLocalInput(from);
        document.getElementById('nt-range-to').value = toLocalInput(now);
      }
      loadNewTrack();
    } else {
      customRange.style.display = 'none';
      loadNewTrack();
    }
  };
  document.getElementById('nt-range-apply').onclick = () => loadNewTrack();
  document.getElementById('nt-back-btn').onclick = () => activateTab(ntEntryTab);
  document.getElementById('nt-accuracy-slider').oninput = (e) => {
    document.getElementById('nt-accuracy-label').textContent = '≤ ' + e.target.value + 'm';
    renderNewTrackContent();
  };
  document.getElementById('nt-show-spikes').onchange = () => renderNewTrackContent();
  document.getElementById('nt-skip-still').onchange = (e) => { ntSkipStillTime = e.target.checked; };
  document.getElementById('nt-play-btn').onclick = () => {
    if (ntPlaybackTimer) ntPausePlayback();
    else if (ntPlaybackMarker) ntResumePlaybackLoop();
    else ntStartPlayback();
  };
  document.getElementById('nt-stop-btn').onclick = () => ntStopPlayback();
  document.getElementById('nt-play-seek').oninput = (e) => ntSeekPlayback(parseInt(e.target.value, 10));
  // Completely independent of history/Firestore -- calls refreshTrackerLocation
  // (a pure read, no Firestore writes at all), then compares the result
  // against the tracker's own already-known lastLat/lastLng/lastVernalTimestamp
  // (live in `registry`, so this works even when the selected window has zero
  // history points to compare against). Same position -> just recenter on it.
  // Different position -> drop a separate yellow "live" marker for it, distinct
  // from the green history trail, without saving it anywhere.
  document.getElementById('nt-locate-btn').onclick = async () => {
    if (!ntCurrentRawId) return;
    const btn = document.getElementById('nt-locate-btn');
    const originalText = btn.textContent;
    const statusEl = document.getElementById('nt-history-status');
    document.getElementById('nt-map-loading').style.display = 'flex';
    btn.textContent = 'Locating...';
    btn.disabled = true;
    try {
      const idToken = await auth.currentUser.getIdToken();
      const resp = await fetch('https://us-central1-flightpathlive-24331.cloudfunctions.net/refreshTrackerLocation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
        body: JSON.stringify({ rawId: ntCurrentRawId })
      }).then(r => r.json());

      if (ntLocateNowMarker) { ntMap.removeLayer(ntLocateNowMarker); ntLocateNowMarker = null; }

      if (!resp.ok || !resp.hasLocation) {
        statusEl.textContent = resp.message || 'No location available right now.';
        statusEl.style.color = '#c0392b';
        // Customer-visible dialog with actionable guidance -- statusEl above
        // is admin-only, so this is the only copy of the message a regular
        // customer will ever see. Fires for the genuine "ok:true,
        // hasLocation:false" case (Vernal has no fix at all for this device
        // yet), and also for Vernal's own "device not bound" error (设备未绑定)
        // -- that one comes back as ok:false/500 from the Cloud Function,
        // but it's actually the exact "registered but never paired through
        // the app" situation this dialog's guidance is written for. It does
        // NOT fire for other resp.ok === false cases -- Vernal's rate
        // limiter ("请求太快"), a Vernal login failure, an expired auth
        // token, etc. -- those are transient/backend problems, not "go
        // re-pair your tracker" situations, so they stay admin-only above.
        const isUnboundError = !resp.ok && typeof resp.message === 'string' && resp.message.includes('未绑定');
        if ((resp.ok && !resp.hasLocation) || isUnboundError) {
          document.getElementById('nt-no-location-modal').classList.add('open');
        }
        return;
      }

      // Compare against what's actually DRAWN on the current map (respects
      // whatever window is selected), not just the tracker's overall known
      // position -- comparing against the latter alone broke on a window
      // with zero points loaded (e.g. "Last 24 hours" showing nothing):
      // the check would say "same as known" and just call setView with
      // nothing already on screen to recenter onto, so nothing visibly
      // appeared. This way, if the position isn't already visible in
      // THIS view, it always gets drawn -- regardless of whether it
      // matches the tracker's last known fix overall.
      const alreadyVisible = ntPlaybackPoints.some(p => p.t === resp.timestamp);

      if (alreadyVisible) {
        // Already drawn somewhere on screen (part of the loaded trail) --
        // just re-center on it, no need to draw anything new.
        ntMap.setView([resp.lat, resp.lng], 15, { animate: true });
      } else {
        // Not visible in the current view -- either a genuinely new
        // position, or the same known position but outside the selected
        // time window (e.g. "Last 24 hours" showing nothing). Either way,
        // nothing's currently drawn here, so it gets its own marker --
        // never mixed into the green history trail and never written to
        // Firestore, exactly a "here's where it is right now" check.
        // Reuses the same pulsing "live" marker style Group Tracking already
        // has (grpPulseIconHtml) instead of a plain static dot -- gives it
        // the breathing halo/ring effect so it visibly reads as "live right
        // now," not just another static history point.
        ntLocateNowMarker = L.marker([resp.lat, resp.lng], {
          icon: L.divIcon({ className: '', html: grpPulseIconHtml('#f5c518'), iconSize: [44, 44], iconAnchor: [22, 22] })
        }).addTo(ntMap);
        ntLocateNowMarker.bindPopup(
          `<b>Live position</b><br>${fmtTime(resp.timestamp)}<br>` +
          `Battery: ${resp.battery != null ? resp.battery + '%' : '—'}<br>` +
          `<i>Not visible in the current time window</i>`
        ).openPopup();
        ntMap.setView([resp.lat, resp.lng], 15, { animate: true });
      }
      // Same fix used everywhere else this map re-centers/fits (see
      // renderNewTrackMap's fitBounds) -- when the panel had zero history,
      // the map was left sitting on a stale/leftover size Leaflet never got
      // a chance to recalculate, so setView's target coordinates were
      // correct but didn't visually render right until something else (a
      // manual zoom, etc.) forced a redraw.
      setTimeout(() => ntMap.invalidateSize(), 50);
    } catch (e) {
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
    } finally {
      btn.textContent = originalText;
      btn.disabled = false;
      document.getElementById('nt-map-loading').style.display = 'none';
    }
  };

  // No third-party library at all -- html2canvas mispositioned tiles (it
  // doesn't handle Leaflet's CSS transform-based panning), and leaflet-image
  // (a library from ~2016) hung indefinitely, most likely incompatible with
  // the modern Leaflet version here. Instead, this reads pixels directly out
  // of the tile/SVG elements Leaflet has ALREADY rendered on screen, using
  // their real on-screen position (getBoundingClientRect, which is always
  // correct no matter how many nested CSS transforms are involved -- no
  // transform math to get wrong). Everything drawn here is already loaded
  // in the DOM, so this is synchronous and can't hang waiting on anything.
  function captureCurrentMapView() {
    const mapEl = document.getElementById('nt-map');
    const mapRect = mapEl.getBoundingClientRect();
    const size = ntMap.getSize();
    const canvas = document.createElement('canvas');
    canvas.width = size.x;
    canvas.height = size.y;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#dddddd';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Only .leaflet-tile-loaded tiles -- anything still loading has no
    // pixels worth copying yet, and skipping it just leaves that patch as
    // background instead of blocking the whole capture on it.
    mapEl.querySelectorAll('.leaflet-tile-loaded').forEach(img => {
      const r = img.getBoundingClientRect();
      try {
        ctx.drawImage(img, r.left - mapRect.left, r.top - mapRect.top, r.width, r.height);
      } catch (e) {
        // Tainted (missed the crossOrigin fix somehow) -- skip this one
        // tile rather than losing the whole capture to a thrown exception.
      }
    });

    return { canvas, ctx, mapRect };
  }

  // Tried serializing Leaflet's own <svg> overlay element and drawing it as
  // an image, but that loses the parent .leaflet-map-pane's own transform
  // (only the <svg>'s own transform survives serializeToString, since its
  // ancestor's transform lives on a DIFFERENT element that never got
  // captured) -- the whole trail came out shifted from its correct spot.
  // Redrawing from Leaflet's actual lat/lng data instead, through the same
  // projection (latLngToContainerPoint) the divIcon markers below use, sidesteps
  // that entirely -- no DOM/CSS to get subtly wrong, since it never reads
  // rendered pixels or transforms for this part at all.
  function drawVectorLayersOnCanvas(ctx) {
    (ntStaticLayers || []).forEach(layer => {
      if (layer instanceof L.Polyline) {
        const latlngs = layer.getLatLngs();
        if (!latlngs.length) return;
        ctx.beginPath();
        latlngs.forEach((ll, i) => {
          const pt = ntMap.latLngToContainerPoint(ll);
          if (i === 0) ctx.moveTo(pt.x, pt.y); else ctx.lineTo(pt.x, pt.y);
        });
        ctx.strokeStyle = layer.options.color;
        ctx.lineWidth = layer.options.weight;
        ctx.globalAlpha = layer.options.opacity != null ? layer.options.opacity : 1;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.stroke();
        ctx.globalAlpha = 1;
      } else if (layer instanceof L.CircleMarker) {
        const pt = ntMap.latLngToContainerPoint(layer.getLatLng());
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, layer.options.radius, 0, 2 * Math.PI);
        if (layer.options.fill !== false) {
          ctx.fillStyle = layer.options.fillColor || layer.options.color;
          ctx.globalAlpha = layer.options.fillOpacity != null ? layer.options.fillOpacity : 0.2;
          ctx.fill();
          ctx.globalAlpha = 1;
        }
        if (layer.options.weight) {
          ctx.strokeStyle = layer.options.color;
          ctx.lineWidth = layer.options.weight;
          ctx.stroke();
        }
      }
      // Arrowhead decorators (polylineDecorator) aren't a Polyline/CircleMarker
      // themselves (it's a LayerGroup of small arrow paths) -- skipped here,
      // so the captured trail shows the route and direction-of-travel dots
      // but not the little arrow ticks along the line.
    });
  }

  // Every point marker on this map is an SVG L.circleMarker (already
  // captured above) EXCEPT the current/last-position one, which uses an
  // L.divIcon pulse effect -- arbitrary HTML/CSS has no pixels a canvas can
  // copy, so it's redrawn here as a plain dot in the same spot instead,
  // using the map's own projection so it lines up exactly with the real
  // marker underneath.
  function drawDivIconMarkersOnCanvas(ctx) {
    const toDraw = [];
    (ntStaticLayers || []).forEach(layer => {
      if (layer instanceof L.Marker) toDraw.push({ marker: layer, color: '#e05a5a' });
    });
    if (ntLocateNowMarker) toDraw.push({ marker: ntLocateNowMarker, color: '#f5c518' });
    if (ntPlaybackMarker) toDraw.push({ marker: ntPlaybackMarker, color: '#3a3a3a' });

    toDraw.forEach(({ marker, color }) => {
      const pt = ntMap.latLngToContainerPoint(marker.getLatLng());
      ctx.beginPath();
      ctx.arc(pt.x, pt.y, 9, 0, 2 * Math.PI);
      ctx.fillStyle = color;
      ctx.fill();
      ctx.lineWidth = 3;
      ctx.strokeStyle = '#ffffff';
      ctx.stroke();
    });
  }

  // Guards against capturing mid-zoom/pan -- tiles are positioned by real
  // CSS layout (always correct for whatever's actually painted right now),
  // but latLngToContainerPoint() reads Leaflet's own internal pixel-origin
  // state, which briefly lags the final view while a zoom/pan transition is
  // still animating. Clicking Capture right after zooming (as opposed to
  // waiting a beat first) was landing the trail/markers at that stale,
  // not-yet-settled position instead of where the map visually finished.
  function waitForMapIdle() {
    return new Promise(resolve => {
      const stillAnimating = ntMap._animatingZoom || (ntMap._panAnim && ntMap._panAnim._inProgress);
      if (!stillAnimating) { resolve(); return; }
      ntMap.once('moveend', resolve);
    });
  }

  // Small branded label in the bottom-right corner of the captured image --
  // a pill background behind the text so it stays legible regardless of
  // what's underneath (satellite imagery, pale roads, dark water, etc.).
  function drawWatermark(canvas, ctx) {
    const text = 'Tracked by flightpathlive.com';
    const fontSize = 15;
    const paddingX = 8;
    const paddingY = 5;
    const margin = 8;
    ctx.font = `600 ${fontSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
    const textWidth = ctx.measureText(text).width;
    const boxW = textWidth + paddingX * 2;
    const boxH = fontSize + paddingY * 2;
    const boxX = canvas.width - boxW - margin;
    const boxY = canvas.height - boxH - margin;

    ctx.fillStyle = 'rgba(27,39,51,0.65)';
    const r = 5;
    ctx.beginPath();
    ctx.moveTo(boxX + r, boxY);
    ctx.arcTo(boxX + boxW, boxY, boxX + boxW, boxY + boxH, r);
    ctx.arcTo(boxX + boxW, boxY + boxH, boxX, boxY + boxH, r);
    ctx.arcTo(boxX, boxY + boxH, boxX, boxY, r);
    ctx.arcTo(boxX, boxY, boxX + boxW, boxY, r);
    ctx.closePath();
    ctx.fill();

    ctx.fillStyle = '#ffffff';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, boxX + paddingX, boxY + boxH / 2 + 1);
  }

  document.getElementById('nt-capture-btn').onclick = async () => {
    const btn = document.getElementById('nt-capture-btn');
    const originalText = btn.textContent;
    const statusEl = document.getElementById('nt-history-status');
    btn.disabled = true;
    btn.textContent = 'Capturing...';
    try {
      await waitForMapIdle();
      const { canvas, ctx } = captureCurrentMapView();
      drawVectorLayersOnCanvas(ctx);
      drawDivIconMarkersOnCanvas(ctx);
      drawWatermark(canvas, ctx);
      const link = document.createElement('a');
      const trackerLabel = (document.getElementById('nt-header-name').textContent || 'tracker').replace(/[^a-z0-9]+/gi, '-');
      link.download = `flightpathlive-map-${trackerLabel}-${Date.now()}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
      // Customer-visible confirmation (unlike statusEl below, which is
      // admin-only) -- a toast rather than changing the button's own text,
      // so it's noticeable even if the button isn't in view/focus.
      showToast('✅ Current map image saved');
      btn.textContent = originalText;
      btn.disabled = false;
    } catch (e) {
      statusEl.textContent = 'Screenshot failed: ' + e.message;
      statusEl.style.color = '#c0392b';
      btn.textContent = originalText;
      btn.disabled = !ntCurrentRawId;
    }
  };

  // Reuses whatever's picked in the window dropdown above -- no separate
  // "how many hours" input, so there's one control for "what window am I
  // looking at" instead of two easily-confused duration pickers. "All
  // time" has no real hour count, so it's treated as 30 days (Vernal's
  // own pullMoreHistory endpoint caps at 30 days anyway).
  function getSelectedWindowHours() {
    const windowVal = document.getElementById('nt-window-select').value;
    if (windowVal === 'custom') {
      const fromVal = document.getElementById('nt-range-from').value;
      const toVal = document.getElementById('nt-range-to').value;
      const fromMs = fromVal ? new Date(fromVal).getTime() : NaN;
      if (!fromMs) return 24;
      return Math.max(1, Math.ceil((Date.now() - fromMs) / (60 * 60 * 1000)));
    }
    const windowHours = parseInt(windowVal, 10);
    return windowHours > 0 ? windowHours : 24 * 30;
  }

  // Whenever the tracker/window changes, this now checks Firestore first and
  // only calls Vernal if that window genuinely isn't covered yet -- there's
  // no separate "Pull History" button anymore, picking a window IS the
  // action. skipAutoFetch guards the one-time recursive reload after a pull
  // so it can't loop forever if Vernal genuinely has nothing older to give
  // (e.g. the tracker just doesn't have data reaching back that far).
  async function loadNewTrack(skipAutoFetch) {
    // Guards against the map (and Leaflet itself) not being ready yet --
    // activateTab('new-track') kicks off initNewTrackMap() but several
    // callers fire loadNewTrack() right after without waiting for that to
    // finish. Awaiting it here (idempotent/memoized, so this resolves
    // instantly on every call after the first) guarantees ntMap exists
    // before renderNewTrackMap() below touches it.
    await initNewTrackMap();
    const rawId = document.getElementById('nt-tracker-select').value;
    const emptyEl = document.getElementById('nt-empty');
    const contentEl = document.getElementById('nt-content');
    const statusEl = document.getElementById('nt-history-status');
    ntCurrentRawId = rawId || null;
    document.getElementById('nt-locate-btn').disabled = !rawId;
    document.getElementById('nt-capture-btn').disabled = !rawId;
    statusEl.textContent = '';
    // Raw Vernal errors/messages ("Vernal login failed: 请求太快" etc.) are
    // meaningless and unprofessional-looking to a regular customer -- only
    // admin needs to see what the background history pull is doing.
    statusEl.style.display = isAdmin ? '' : 'none';

    // Detach whatever live listener was set up for the previous tracker or
    // window before attaching a new one -- otherwise switching trackers
    // leaves old listeners running in the background indefinitely.
    if (ntDetectionsUnsubscribe) { ntDetectionsUnsubscribe(); ntDetectionsUnsubscribe = null; }

    const pigeonBadge = document.getElementById('nt-header-pigeon-badge');
    if (!rawId) {
      document.getElementById('nt-header-name').textContent = 'Select a tracker';
      pigeonBadge.style.display = 'none';
      emptyEl.style.display = 'block';
      contentEl.style.display = 'none';
      document.getElementById('nt-map-loading').style.display = 'none';
      return;
    }
    const regDataForHeader = registry[rawId] || {};
    // Title is always the tracker's own name now (nickname, or the MAC/rawId
    // if it doesn't have one) -- the assigned pigeon (if any) gets its own
    // separate badge next to it instead of replacing the title.
    document.getElementById('nt-header-name').textContent = regDataForHeader.nickname || rawId;
    const pigeon = matchedPigeon(rawId);
    if (pigeon) {
      document.getElementById('nt-header-pigeon-name').textContent = pigeon.name;
      pigeonBadge.style.display = 'inline-flex';
    } else {
      pigeonBadge.style.display = 'none';
    }
    emptyEl.style.display = 'none';
    contentEl.style.display = 'block';

    const windowVal = document.getElementById('nt-window-select').value;
    let beginTime = 0;
    let endTime = Date.now();
    if (windowVal === 'custom') {
      const fromVal = document.getElementById('nt-range-from').value;
      const toVal = document.getElementById('nt-range-to').value;
      const fromMs = fromVal ? new Date(fromVal).getTime() : NaN;
      const toMs = toVal ? new Date(toVal).getTime() : NaN;
      if (!fromMs || !toMs || fromMs >= toMs) {
        alert('Please choose a valid "from" date/time before the "to" date/time.');
        return;
      }
      beginTime = fromMs;
      endTime = toMs;
    } else {
      const windowHours = parseInt(windowVal, 10);
      beginTime = windowHours > 0 ? Date.now() - windowHours * 60 * 60 * 1000 : 0;
    }
    document.getElementById('nt-map-loading').style.display = 'flex';
    // Disabled for the whole loading window (not just while "Locate Now"
    // itself is running) -- otherwise someone in a hurry could switch the
    // window dropdown, see the spinner, and press "Locate Now" thinking
    // it's needed to make the new window actually load.
    document.getElementById('nt-locate-btn').disabled = true;

    // Scoped to the selected window, not the tracker's whole history -- a
    // long-lived tracker accumulates a detection roughly every 2 minutes
    // from the poller, so fetching every single one every time "Open map"
    // was clicked (regardless of what window was even selected) was the
    // actual cause of the slow load. "All time" genuinely wants everything,
    // so it skips the range filter and stays unbounded. This is a LIVE
    // listener (not a one-time .get()) so the map/stats refresh on their
    // own whenever the poller saves a new point for this tracker -- no flat
    // doc-count cap here on purpose, unlike the old dashboard's unscoped
    // "last 200 across every tracker" overview listener: this one is
    // already bounded by tracker ID + the window you picked, which is a
    // tighter, more intentional scope than an arbitrary count.
    let query = db.collection('detections').where('rawCharacteristicId', '==', rawId);
    if (beginTime > 0) {
      query = query
        .where('timestamp', '>=', firebase.firestore.Timestamp.fromMillis(beginTime))
        .where('timestamp', '<=', firebase.firestore.Timestamp.fromMillis(endTime));
    }
    // Cheap, one-time, single-document lookup of just the earliest saved
    // point for this tracker (used only to decide whether the window
    // already has full coverage) -- doesn't need to be live.
    const earliestSnap = await db.collection('detections')
      .where('rawCharacteristicId', '==', rawId)
      .orderBy('timestamp', 'asc')
      .limit(1)
      .get();
    ntEarliestSavedTs = earliestSnap.empty ? null : earliestSnap.docs[0].data().timestamp.toMillis();

    // "All time" (beginTime === 0) has no fixed point to check coverage
    // against, so it's excluded here -- it just shows whatever's saved,
    // same as before. Every other window (including custom range) gets
    // auto-filled from Vernal if Firestore doesn't already reach back
    // that far. ntNoOlderHistory remembers "Vernal confirmed nothing
    // older" per tracker+window for this session, so re-opening the same
    // tracker doesn't repeat the same slow, futile round-trip every time.
    // For "custom", windowVal is always just the literal string "custom"
    // regardless of which dates were picked -- keying off that alone would
    // wrongly skip re-checking Vernal for a totally different custom range
    // just because some earlier custom range once came back empty. Using
    // beginTime (the actual resolved start of the window) instead makes the
    // key specific to the dates actually chosen.
    //
    // Computed here (before the Firestore listener even starts) rather than
    // after it resolves -- everything needsFetch depends on is already
    // known at this point, and knowing it up front is what lets the loading
    // spinner below stay combined across both steps instead of hiding after
    // Firestore alone and leaving the Vernal round-trip invisible.
    const gapKey = rawId + ':' + (windowVal === 'custom' ? 'custom-' + beginTime : windowVal);
    const needsFetch = !skipAutoFetch && beginTime > 0 && !ntNoOlderHistory.has(gapKey) &&
      (ntEarliestSavedTs === null || ntEarliestSavedTs > beginTime);

    let isFirstSnapshot = true;
    await new Promise(resolve => {
      ntDetectionsUnsubscribe = query.onSnapshot(snapshot => {
        // Skip re-rendering while a flight replay is actively playing -- a
        // live update landing mid-animation would otherwise yank the
        // trail/marker out from under it. The fresh data still lands in
        // ntAllPoints next time something else triggers a render (stopping
        // playback, switching tracker/window, etc.).
        if (ntPlaybackTimer && !isFirstSnapshot) return;

        const points = [];
        snapshot.forEach(doc => {
          const d = doc.data();
          if (typeof d.latitude !== 'number' || typeof d.longitude !== 'number') return;
          const ts = d.timestamp && d.timestamp.toMillis ? d.timestamp.toMillis() : 0;
          points.push({
            id: doc.id, lat: d.latitude, lng: d.longitude, t: ts,
            battery: typeof d.battery === 'number' ? d.battery : null,
            accuracy: typeof d.accuracy === 'number' ? d.accuracy : null,
            // Already-geocoded address, if a previous lookup (by anyone, any
            // session) saved one back onto this exact point -- see
            // resolvePointAddress() below, which checks this before ever
            // calling Nominatim again for it.
            address: typeof d.address === 'string' ? d.address : null
          });
        });
        points.sort((a, b) => a.t - b.t);
        ntAllPoints = points;

        // Show what's already saved RIGHT AWAY -- don't make the user wait
        // on Vernal just to see the page. The Vernal check (if any) below
        // only runs once, right after this first snapshot.
        renderNewTrackContent();

        if (isFirstSnapshot) {
          isFirstSnapshot = false;
          // Only hide here if there's no Vernal step coming next -- if
          // needsFetch is true, the spinner stays up through that too, so
          // "Loading flight data..." represents the WHOLE combined check
          // (Firestore + Vernal), not just the fast local half of it. Without
          // this, the spinner would disappear the instant Firestore answered
          // even though Vernal might still be working (or failing) invisibly
          // in the background.
          if (!needsFetch) {
            document.getElementById('nt-map-loading').style.display = 'none';
            document.getElementById('nt-locate-btn').disabled = !ntCurrentRawId;
          }
          resolve();
        }
      });
    });

    if (needsFetch) {
      try {
        const hours = getSelectedWindowHours();
        const idToken = await auth.currentUser.getIdToken();
        const resp = await fetch('https://us-central1-flightpathlive-24331.cloudfunctions.net/pullMoreHistory', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
          body: JSON.stringify({ rawId, hours })
        }).then(r => r.json());
        if (resp.ok) {
          if (resp.historyPointsSaved > 0) {
            statusEl.textContent = `Added ${resp.historyPointsSaved} point(s) of older history.`;
            statusEl.style.color = '#2e8b57';
            // No explicit reload needed anymore -- the live listener above
            // picks up these newly-saved older points on its own as soon as
            // pullMoreHistory writes them to Firestore.
          } else {
            statusEl.textContent = '';
            ntNoOlderHistory.add(gapKey); // nothing further back exists -- stop asking Vernal for this tracker+window
          }
        } else {
          statusEl.textContent = resp.message;
          statusEl.style.color = '#c0392b';
        }
      } catch (e) {
        statusEl.textContent = e.message;
        statusEl.style.color = '#c0392b';
      } finally {
        document.getElementById('nt-map-loading').style.display = 'none';
        document.getElementById('nt-locate-btn').disabled = !ntCurrentRawId;
      }
    }
  }

  function renderNewTrackContent() {
    if (!ntCurrentRawId) return;
    const maxAccuracy = parseInt(document.getElementById('nt-accuracy-slider').value, 10);
    // Points with no accuracy recorded (e.g. web-bind/manual-wake sources)
    // are kept -- only points with a KNOWN accuracy worse than the slider
    // get filtered out.
    const accuracyFiltered = ntAllPoints.filter(p => p.accuracy == null || p.accuracy <= maxAccuracy);
    // filterOutliers() drops any point implying an unrealistic speed jump
    // from the last KEPT point -- e.g. one bad GPS fix that briefly puts
    // the bird hundreds of km away -- so it never counts toward
    // distance/points/stats below. Those dropped points can still be shown
    // on the map (dashed orange) via the "Show filtered points" toggle.
    const points = filterOutliers(accuracyFiltered);
    const keptTimestamps = new Set(points.map(p => p.t));
    const spikePoints = accuracyFiltered.filter(p => !keptTimestamps.has(p.t));
    const regData = registry[ntCurrentRawId] || {};

    const spikeToggleWrap = document.getElementById('nt-spike-toggle-wrap');
    spikeToggleWrap.style.display = spikePoints.length > 0 ? 'inline-block' : 'none';
    document.getElementById('nt-spike-count').textContent = spikePoints.length;

    const batteryPct = points.length > 0 ? (points[points.length - 1].battery ?? regData.lastVernalBattery ?? null) : null;
    document.getElementById('nt-stat-battery').textContent = batteryPct != null ? batteryPct + '%' : '—';
    const batteryFill = document.getElementById('nt-battery-bar-fill');
    batteryFill.style.width = (batteryPct != null ? batteryPct : 0) + '%';
    batteryFill.style.background = batteryPct == null ? '#eef0f2' : batteryPct <= 20 ? '#c0392b' : batteryPct <= 50 ? '#f57c00' : '#2e8b57';
    document.getElementById('nt-stat-lastseen').textContent = points.length > 0 ? timeAgo(points[points.length - 1].t) : '—';
    document.getElementById('nt-stat-lastchecked').textContent =
      regData.lastPolledAt && regData.lastPolledAt.toMillis ? timeAgo(regData.lastPolledAt.toMillis()) : '—';
    document.getElementById('nt-stat-points').textContent = points.length;

    let totalDistanceKm = 0;
    for (let i = 1; i < points.length; i++) {
      totalDistanceKm += haversineKm(points[i - 1].lat, points[i - 1].lng, points[i].lat, points[i].lng);
    }
    document.getElementById('nt-stat-distance').textContent = points.length > 1 ? totalDistanceKm.toFixed(1) + ' km' : '—';

    document.getElementById('nt-stat-address').textContent = points.length > 0 ? 'Looking up...' : '—';
    if (points.length > 0) {
      const latest = points[points.length - 1];
      reverseGeocode(latest.lat, latest.lng).then(addr => {
        document.getElementById('nt-stat-address').textContent = addr;
      });
    }

    renderNewTrackMap(points, document.getElementById('nt-show-spikes').checked ? spikePoints : []);
    renderNewTrackHistory(points);
  }

  // This org's own loft marker (if set) plus distance rings around it --
  // same idea as the group map's version, just for a single tracker and
  // always "your own" loft (there's only ever one org involved here).
  // Redrawn as a whole on any toggle change, and again after every full
  // renderNewTrackMap rebuild (which clears every non-tile layer).
  function ntRenderExtraLayers() {
    if (!ntMap) return;
    if (ntExtraLayersGroup) ntMap.removeLayer(ntExtraLayersGroup);
    ntExtraLayersGroup = L.layerGroup().addTo(ntMap);
    if (!currentOrg || !currentOrg.homeLoft) return;
    const center = [currentOrg.homeLoft.lat, currentOrg.homeLoft.lng];
    L.marker(center, {
      icon: L.divIcon({ className: '', html: '<i class="fa-solid fa-house" style="color:#2f6fed;font-size:18px;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.4));"></i>', iconSize: [18, 18], iconAnchor: [9, 16] })
    }).addTo(ntExtraLayersGroup).bindTooltip('Your loft', { permanent: ntShowLoftNames, direction: 'top', offset: [0, -14] });
    if (ntShowDistanceRings) {
      [25, 50, 100].forEach(km => {
        L.circle(center, { radius: km * 1000, color: '#2c3540', weight: 1.5, dashArray: '4,4', fill: false }).addTo(ntExtraLayersGroup);
        const labelPoint = L.GeometryUtil && L.GeometryUtil.destination
          ? L.GeometryUtil.destination(L.latLng(center), 0, km * 1000)
          : L.latLng(center[0] + km / 111, center[1]);
        L.marker(labelPoint, {
          icon: L.divIcon({ className: '', html: `<span style="background:#fff;padding:1px 6px;border-radius:4px;font-size:11px;color:#4a5560;box-shadow:0 1px 3px rgba(0,0,0,0.25);white-space:nowrap;">${km} km</span>`, iconSize: [0, 0] })
        }).addTo(ntExtraLayersGroup);
      });
    }
  }

  function renderNewTrackMap(points, spikePoints) {
    if (!ntMapInitialized) return;
    ntStopPlayback(true); // true = about to rebuild everything anyway, don't bother restoring first
    ntMap.eachLayer(layer => { if (layer instanceof L.TileLayer) return; ntMap.removeLayer(layer); });

    ntPlaybackPoints = points;
    // Precomputed once per load, not per-frame -- see STILL_DISTANCE_METERS
    // above ("Skip still time"). ntStillSegments[i] describes the gap
    // between points[i] and points[i+1].
    ntStillSegments = points.slice(0, -1).map((p, i) =>
      haversineKm(p.lat, p.lng, points[i + 1].lat, points[i + 1].lng) * 1000 < STILL_DISTANCE_METERS
    );
    ntStaticLayers = [];
    // Lets a Location History row jump back to its exact marker on the map
    // (see the click handler in renderNewTrackHistory) -- timestamp is a
    // reliable unique key per point, unlike lat/lng which can repeat.
    ntPointMarkersByTime.clear();
    document.getElementById('nt-play-btn').disabled = points.length < 2;
    document.getElementById('nt-play-seek').disabled = points.length < 2;

    if (points.length === 0) {
      // Without this, the map keeps showing wherever the PREVIOUS tracker
      // you viewed was centered -- easy to mistake for this tracker's real
      // location when it actually has none at all yet. Reset to the same
      // neutral default initNewTrackMap() starts on.
      ntMap.setView([51.5074, -0.1278], 6);
      setTimeout(() => ntMap.invalidateSize(), 50);
      ntRenderExtraLayers();
      return;
    }

    const latlngs = points.map(p => [p.lat, p.lng]);

    // One continuous line connecting every point in order, oldest -> newest
    // -- matches the competitor's map and our own playback trail, both of
    // which always draw one unbroken line regardless of time gaps between
    // points. Drawn as two stacked polylines (a wider white "casing" under
    // a thinner dark grey line) for the white-outlined-dark-line look,
    // since Leaflet polylines don't support a stroke/outline directly.
    const mainLineCasing = L.polyline(latlngs, { color: '#ffffff', weight: 6, opacity: 0.9 }).addTo(ntMap);
    ntStaticLayers.push(mainLineCasing);
    const mainLine = L.polyline(latlngs, { color: '#3a3a3a', weight: 3, opacity: 0.9 }).addTo(ntMap);
    ntStaticLayers.push(mainLine);
    // Small arrowheads repeated along the line, pointing in the direction
    // of travel (oldest -> newest), so the flight direction is visible at
    // a glance instead of just a plain line between dots.
    if (window.L.polylineDecorator) {
      const decorator = L.polylineDecorator(mainLine, {
        patterns: [{
          offset: 20, repeat: 60,
          symbol: L.Symbol.arrowHead({ pixelSize: 9, pathOptions: { color: '#ffffff', weight: 1, fillColor: '#3a3a3a', fillOpacity: 0.95 } })
        }]
      }).addTo(ntMap);
      ntStaticLayers.push(decorator);
    }

    points.forEach((p, i) => {
      const isLast = i === points.length - 1;
      let marker;
      if (isLast) {
        marker = L.marker([p.lat, p.lng], {
          icon: L.divIcon({
            className: '',
            html: '<div class="nt-pulse-icon"><div class="nt-pulse-halo"></div><div class="nt-pulse-ring"></div><div class="nt-pulse-dot"></div></div>',
            iconSize: [44, 44],
            iconAnchor: [22, 22]
          })
        }).addTo(ntMap);
      } else {
        marker = L.circleMarker([p.lat, p.lng], {
          radius: 5, color: '#2e8b57', fillColor: '#2e8b57', fillOpacity: 1
        }).addTo(ntMap);
      }

      // Speed since the previous fix, m/min -- no previous point for the
      // very first fix, so that line is just omitted there.
      let speedText = null;
      if (i > 0) {
        const prev = points[i - 1];
        const meters = haversineKm(prev.lat, prev.lng, p.lat, p.lng) * 1000;
        const minutes = (p.t - prev.t) / 60000;
        if (minutes > 0) speedText = Math.round(meters / minutes) + ' m/min';
      }
      const accuracyText = p.accuracy != null ? '±' + Number(p.accuracy).toFixed(2) + 'm' : '—';

      // "Display tracker names" permanently labels only the current
      // position (isLast), same treatment as the group map's version --
      // every other point keeps the usual hover-for-details tooltip.
      if (isLast && ntShowTrackerNames) {
        const regDataForLabel = registry[ntCurrentRawId] || {};
        marker.bindTooltip(regDataForLabel.nickname || ntCurrentRawId, { className: 'nt-point-tooltip', permanent: true, direction: 'top', offset: [0, -20] });
      } else {
        // Hover: compact one-line summary. Leaflet tooltips already open on
        // hover / close on mouseout by default, no extra wiring needed.
        marker.bindTooltip(
          [fmtTime(p.t), speedText, accuracyText].filter(Boolean).join(' · '),
          { className: 'nt-point-tooltip', direction: 'top', offset: [0, -8] }
        );
      }

      // Click: fuller vertical popup, with the location name looked up on
      // demand the first time this popup is opened (not upfront for every
      // point -- reverseGeocode is rate-limited).
      // Each line is icon + text as two flex children in one row -- keeps
      // the icon pinned to the top-left of that line no matter how long the
      // text is, instead of relying on inline text flow (which was letting
      // the popup's narrow width wrap right after the icon on its own).
      const popupLine = (icon, html) => `<div class="nt-popup-line"><span class="nt-popup-line-icon">${icon}</span><span>${html}</span></div>`;
      const popupBody = () => `
        ${popupLine('🕒', `<b>${fmtTime(p.t)}</b>`)}
        ${popupLine('🔋', `Battery: ${p.battery != null ? p.battery + '%' : '—'}`)}
        ${speedText ? popupLine('💨', speedText + ' since the previous fix') : ''}
        ${popupLine('📍', `<span class="nt-popup-address" data-lat="${p.lat}" data-lng="${p.lng}">Looking up location…</span>`)}
        ${popupLine('🎯', `Accuracy: ${accuracyText}`)}
        ${popupLine('🌐', `${p.lat.toFixed(5)}, ${p.lng.toFixed(5)}`)}
        ${popupLine('🔗', `<a href="#" class="nt-popup-share">Share / directions</a>`)}
      `;
      marker.bindPopup(popupBody());
      marker.on('popupopen', () => {
        const el = marker.getPopup().getElement();
        resolvePointAddress(p, addr => {
          const span = el && el.querySelector('.nt-popup-address');
          if (span) span.textContent = addr;
        });
        const shareLink = el && el.querySelector('.nt-popup-share');
        if (shareLink) shareLink.onclick = (ev) => { ev.preventDefault(); sharePointLocation(p); };
      });

      ntStaticLayers.push(marker);
      ntPointMarkersByTime.set(p.t, marker);
    });

    // Filtered/spike points shown only when the "Show filtered points" toggle
    // is on -- never part of the polyline, distance total, or fitBounds.
    (spikePoints || []).forEach(p => {
      const marker = L.circleMarker([p.lat, p.lng], {
        radius: 6, color: '#e65100', fillColor: '#f57c00', fillOpacity: 0.35, weight: 2, dashArray: '4,3'
      }).addTo(ntMap);
      marker.bindPopup(`<b>${fmtTime(p.t)}</b><br><i>Filtered out — implied an unrealistic jump</i><br>Accuracy: ${p.accuracy != null ? '±' + p.accuracy + 'm' : '—'}`);
      marker.on('mouseover', () => marker.openPopup());
      marker.on('mouseout', () => marker.closePopup());
      ntStaticLayers.push(marker);
    });

    ntMap.fitBounds(L.latLngBounds(latlngs), { padding: [30, 30], maxZoom: 15 });
    setTimeout(() => ntMap.invalidateSize(), 50);
    ntRenderExtraLayers();
  }

  // Auto-loads a row's address the moment it's actually scrolled into view,
  // instead of requiring a click -- competitor sites just show the address
  // directly. Can't simply geocode all rows up front though: this table can
  // hold 100+ points, and Nominatim's free reverse-geocoding service only
  // allows ~1 request/second, so kicking off every row at once would take
  // minutes and hammer a free public service for addresses nobody's even
  // looking at yet. One shared IntersectionObserver, scoped to the table's
  // own scroll container (not the whole page), fires queueReverseGeocode
  // (which already paces requests correctly) only as each row scrolls in,
  // then stops watching that row -- so it's still lazy and rate-limit-safe,
  // just automatic instead of click-triggered.
  let ntHistoryRowObserver = null;
  function ensureNtHistoryRowObserver() {
    if (ntHistoryRowObserver) return ntHistoryRowObserver;
    ntHistoryRowObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const cell = entry.target;
        ntHistoryRowObserver.unobserve(cell);
        cell.textContent = 'Looking up...';
        resolvePointAddress(cell._ntPoint, addr => { cell.textContent = addr; });
      });
    // Scoped to #db-panel-new-track specifically -- Group Tracking's detail
    // view has its OWN separate element with this exact same class, and a
    // plain class selector was grabbing that one instead (the first match
    // in document order). An IntersectionObserver's root has to be an actual
    // ancestor of what it's observing, or intersections never fire at all --
    // that's why every row was stuck showing raw coordinates forever.
    }, { root: document.querySelector('#db-panel-new-track .nt-history-table-wrap'), rootMargin: '200px 0px' });
    return ntHistoryRowObserver;
  }

  function renderNewTrackHistory(points) {
    const body = document.getElementById('nt-history-body');
    document.getElementById('nt-history-count').textContent = points.length + ' locations';
    body.innerHTML = '';
    const observer = ensureNtHistoryRowObserver();
    // Newest first for the table, even though the map/distance math above
    // uses oldest-first order.
    [...points].reverse().forEach(p => {
      const row = document.createElement('tr');
      const accuracyStr = p.accuracy != null ? '±' + p.accuracy + 'm' : '—';
      // Already has a saved address (see the detections onSnapshot handler)
      // -- show it straight away, nothing to look up or observe for this row.
      const initialText = p.address || (p.lat.toFixed(5) + ', ' + p.lng.toFixed(5));
      row.innerHTML = `
        <td>${fmtTime(p.t)}</td>
        <td><span class="nt-geocode-btn">${initialText}</span></td>
        <td>${accuracyStr}</td>
      `;
      const locationCell = row.querySelector('.nt-geocode-btn');
      if (!p.address) {
        locationCell._ntPoint = p;
        observer.observe(locationCell);
      }
      // Jumps back to this exact point on the map -- same marker the trail
      // already draws, found by timestamp (see ntPointMarkersByTime, filled
      // in by renderNewTrackMap). Scrolls the map into view first since on
      // a long history list the map can be scrolled well out of sight by
      // the time someone clicks a row down here.
      row.onclick = () => {
        const marker = ntPointMarkersByTime.get(p.t);
        if (!marker) return;
        document.getElementById('nt-map').scrollIntoView({ behavior: 'smooth', block: 'center' });
        ntMap.setView([p.lat, p.lng], Math.max(ntMap.getZoom(), 15), { animate: true });
        marker.openPopup();
      };
      body.appendChild(row);
    });
  }

  // JOIN FLIGHT -- the actual destination behind a group's "Invite the
  // club" link. Reached via ?joinFlight=<groupId>, triggered once from the
  // auth success path below (search "joinFlightGroupId"), same pattern as
  // New Track/Group Tracking having no sidebar item of their own.
  //
  // Deliberately avoids reading the "organizations" collection anywhere --
  // that's locked to each org's own owner (a visiting fancier from a
  // different account can't read someone else's org name), unlike
  // trackerGroups/trackers, which are both publicly readable. That's why
  // "Organised by" reads a plain organiserName field stamped onto the
  // group at creation (see the Save handler) instead of looking an org up,
  // and "Who's flying" lists individual trackers (from the public
  // `registry` cache) rather than grouping by owning account.
  async function loadJoinFlightView(groupId) {
    activateTab('join-flight');
    document.getElementById('join-flight-loading').style.display = 'block';
    document.getElementById('join-flight-notfound').style.display = 'none';
    document.getElementById('join-flight-content').style.display = 'none';

    let groupSnap;
    try {
      groupSnap = await db.collection('trackerGroups').doc(groupId).get();
    } catch (e) {
      groupSnap = null;
    }
    if (!groupSnap || !groupSnap.exists) {
      document.getElementById('join-flight-loading').style.display = 'none';
      document.getElementById('join-flight-notfound').style.display = 'block';
      return;
    }
    const g = groupSnap.data();

    document.getElementById('join-flight-loading').style.display = 'none';
    document.getElementById('join-flight-content').style.display = 'block';
    document.getElementById('join-flight-name').textContent = g.name || 'Flight';
    document.getElementById('join-flight-organiser').textContent = getGroupOrganiserName(g);

    const startMs = g.startTime && g.startTime.toMillis ? g.startTime.toMillis() : null;
    const isOngoing = !g.endTime;

    // Summary card -- same helpers/format as the Group Tracking cards.
    document.getElementById('join-flight-status-badge').innerHTML = groupStatusBadgeHtml(g);
    const sharedEl = document.getElementById('join-flight-shared');
    const sharedHtml = grpSharedInfoHtml(g);
    sharedEl.innerHTML = sharedHtml;
    sharedEl.style.display = sharedHtml ? '' : 'none';
    document.getElementById('join-flight-daterange').textContent = grpCardDateStr(g);
    // Only shown when a real release point name exists -- never invented.
    const releaseName = g.releasePoint && g.releasePoint.placeName;
    document.getElementById('join-flight-release-row').style.display = releaseName ? '' : 'none';
    document.getElementById('join-flight-release').textContent = releaseName ? releaseName + ' (Release Point)' : '';
    document.getElementById('join-flight-ago').textContent = grpCardTimeMetaStr(g);
    document.getElementById('join-flight-stats').innerHTML = grpCardStatsHtml(g);
    document.getElementById('join-flight-loggedin').textContent =
      'You are logged in as ' + ((currentOrg && currentOrg.name) || 'your account') +
      (currentOrg && currentOrg.homeLoft && currentOrg.homeLoft.city ? ' (Loft: ' + currentOrg.homeLoft.city + ')' : '');
    document.getElementById('join-flight-crumb-groups').onclick = (e) => { e.preventDefault(); activateTab('group-tracking'); };
    renderJoinFlightMap(g);

    document.getElementById('join-flight-underway-notice').style.display = (isOngoing && startMs && startMs <= Date.now()) ? 'block' : 'none';
    document.getElementById('join-flight-ended-notice').style.display = isOngoing ? 'none' : 'block';

    // Names the actual release moment instead of just "the release" --
    // matches the competitor's wording, and it's a claim our own sharing
    // logic already backs up (only startTime-and-later positions are ever
    // read for a tracker entered here).
    document.getElementById('join-flight-share-from-line').innerHTML =
      'Sharing starts at the release' + (startMs ? `, <b>${fmtDateShort(startMs)}</b>` : '') +
      '. Nothing your birds reported before that moment is shared — not a minute of it — and nothing from any tracker you don\'t tick.';

    renderJoinFlightParticipants(g);

    // The organiser opening their own invite link gets an extra notice
    // pointing at the Edit form (the normal way to add trackers), but the
    // checklist/withdraw section below is still shown to them too -- it's
    // their only real way to withdraw (or resume) one of their own already-
    // entered birds, since removing one via Edit is blocked once the
    // flight has started (see the grp-add-save guard) and there's no other
    // Withdraw entry point for the organiser's own participant entry.
    const isOwnFlight = !!(currentOrg && g.orgId === currentOrg.slug);
    document.getElementById('join-flight-own-section').style.display = isOwnFlight ? 'block' : 'none';

    if (isOwnFlight) {
      document.getElementById('join-flight-own-edit-link').onclick = (e) => {
        e.preventDefault();
        activateTab('group-tracking');
        openGroupEditModal(groupId);
      };
      document.getElementById('join-flight-own-map-btn').onclick = () => {
        activateTab('group-tracking');
        openGroupDetail(groupId);
      };
    }

    // A returning visitor who's already joined sees a different button row
    // (Enter more birds + Open the map, not a bare "Join") and gets the
    // option to withdraw -- matches the competitor's own revisit view.
    const myEntry = (g.participants && g.participants[currentOrg.slug]) || null;
    const alreadyJoined = !!(myEntry && (myEntry.trackerIds || []).length > 0);
    const alreadyWithdrawn = !!(myEntry && myEntry.withdrawnAt);

    const withdrawSection = document.getElementById('join-flight-withdraw-section');
    const withdrawnNotice = document.getElementById('join-flight-withdrawn-notice');
    const endedMapBtn = document.getElementById('join-flight-ended-openmap-btn');

    if (!isOngoing) {
      // Nothing left to pick or withdraw once it's over -- the checklist
      // card (with its own Join/Enter-more/Open-map buttons) is hidden
      // entirely; the only thing worth offering is a way to see the final
      // map, and only to someone who actually had birds in it.
      document.getElementById('join-flight-checklist-card').style.display = 'none';
      withdrawSection.style.display = 'none';
      withdrawnNotice.style.display = alreadyWithdrawn ? 'block' : 'none';
      endedMapBtn.style.display = alreadyJoined ? '' : 'none';
      endedMapBtn.onclick = () => {
        activateTab('group-tracking');
        openGroupDetail(groupId);
      };
      return;
    }
    document.getElementById('join-flight-checklist-card').style.display = 'block';
    endedMapBtn.style.display = 'none';
    renderJoinFlightTrackerChecklist(g);

    const statusEl = document.getElementById('join-flight-status');
    const btn = document.getElementById('join-flight-btn');
    btn.innerHTML = '<i class="fa-solid fa-plus"></i> Add to Flight';
    if (g.clubShareEnabled === false) {
      statusEl.textContent = 'The organiser has turned off sharing for this flight — new fanciers can\'t join right now.';
      statusEl.style.color = '#c0392b';
      btn.disabled = true;
    } else if (!hasLoftLocation()) {
      // No loft location = no arrival point, so this member's birds could
      // never be ranked -- joining is blocked until it's set in Settings.
      statusEl.innerHTML = GRP_LOFT_REQUIRED_MSG + ' <a href="#" id="join-flight-loft-link" style="color:#2f6fed;font-weight:700;">Set my loft location</a>';
      statusEl.style.color = '#c0392b';
      btn.disabled = true;
      document.getElementById('join-flight-loft-link').onclick = (e) => { e.preventDefault(); goToLoftSettings(); };
    } else {
      statusEl.textContent = '';
      btn.disabled = false;
      btn.onclick = () => submitJoinFlight(groupId, g.name);
    }

    const openMapBtn = document.getElementById('join-flight-openmap-btn');
    openMapBtn.style.display = alreadyJoined ? '' : 'none';
    openMapBtn.onclick = () => {
      activateTab('group-tracking');
      openGroupDetail(groupId);
    };

    withdrawSection.style.display = (alreadyJoined && !alreadyWithdrawn) ? 'block' : 'none';
    withdrawnNotice.style.display = alreadyWithdrawn ? 'block' : 'none';
    if (alreadyJoined && !alreadyWithdrawn) {
      document.getElementById('join-flight-withdraw-text').textContent =
        'This flight has started, so your birds’ positions are already part of its record and the other fanciers have seen them. Withdrawing stops new positions being shared from this moment on. What your birds have already flown stays on the map, marked as withdrawn.';
      document.getElementById('join-flight-withdraw-btn').onclick = () => submitWithdrawFromFlight(groupId);
    }
  }

  function renderJoinFlightTrackerChecklist(g) {
    const listEl = document.getElementById('join-flight-tracker-checklist');
    const alreadyIn = new Set(g.trackerIds || []);
    // A member who has withdrawn must be able to tick their own birds again
    // to resume -- otherwise they'd sit locked as "already in this flight"
    // with nothing left to pick, and could never rejoin.
    const myEntry = g.participants && currentOrg ? g.participants[currentOrg.slug] : null;
    const withdrawnOwn = new Set(myEntry && myEntry.withdrawnAt ? (myEntry.trackerIds || []) : []);
    const myRawIds = Object.keys(myTrackerMemberships).sort();
    if (myRawIds.length === 0) {
      listEl.innerHTML = '<div style="color:#8a97a3;">You don\'t have any trackers on your account yet.</div>';
      return;
    }
    listEl.innerHTML = myRawIds.map(rawId => {
      const regData = registry[rawId] || {};
      const pigeon = allPigeonDocs.find(d => d.id === regData.assignedPigeonId);
      const label = (regData.nickname || rawId) + (pigeon ? ' — ' + pigeon.p.name : '');
      const isWithdrawn = withdrawnOwn.has(rawId);
      const isAlready = alreadyIn.has(rawId) && !isWithdrawn;
      return `<div class="grp-tracker-row"><input type="checkbox" id="jf-trk-${rawId}" value="${rawId}" ${isAlready ? 'checked disabled' : ''}><label for="jf-trk-${rawId}">${label}${isAlready ? ' <span style="color:#8a97a3;">(already in this flight)</span>' : ''}${isWithdrawn ? ' <span style="color:#8a97a3;">(withdrawn — tick to resume)</span>' : ''}</label></div>`;
    }).join('');
    listEl.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.onchange = updateJoinFlightDdLabel; });
    updateJoinFlightDdLabel();
  }

  // Dropdown-style picker: the checklist itself (same ids/checkboxes
  // submitJoinFlight reads) lives inside a panel opened by this button.
  function updateJoinFlightDdLabel() {
    const labelEl = document.getElementById('join-flight-dd-label');
    if (!labelEl) return;
    const n = document.querySelectorAll('#join-flight-tracker-checklist input[type="checkbox"]:checked:not(:disabled)').length;
    labelEl.textContent = n === 0 ? 'Select your birds...' : n + ' selected';
  }
  document.getElementById('join-flight-dd-btn').onclick = (e) => {
    e.stopPropagation();
    document.getElementById('join-flight-dd').classList.toggle('open');
  };
  document.addEventListener('click', (e) => {
    const dd = document.getElementById('join-flight-dd');
    if (dd && !dd.contains(e.target)) dd.classList.remove('open');
  });

  // Small Release Point preview -- a plain read-only map, not the live
  // tracking view (that stays on the group's own map page).
  let jfMap = null;
  async function renderJoinFlightMap(g) {
    const wrap = document.getElementById('join-flight-map-wrap');
    const rp = g.releasePoint;
    if (!rp || typeof rp.lat !== 'number' || typeof rp.lng !== 'number') { wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    try {
      await ensureLeafletLoaded();
      if (jfMap) { jfMap.remove(); jfMap = null; }
      jfMap = L.map('join-flight-map', { scrollWheelZoom: false }).setView([rp.lat, rp.lng], 10);
      NT_TILE_LAYERS.detailed().addTo(jfMap);
      L.marker([rp.lat, rp.lng], {
        icon: L.divIcon({ className: '', html: '<i class="fa-solid fa-location-dot" style="color:#e53935;font-size:30px;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.4));"></i>', iconSize: [24, 30], iconAnchor: [12, 29] })
      }).addTo(jfMap).bindTooltip('Release Point', { permanent: true, direction: 'bottom', offset: [0, 2] });
      setTimeout(() => { if (jfMap) { jfMap.invalidateSize(); jfMap.setView([rp.lat, rp.lng], 10); } }, 150);
    } catch (e) {
      wrap.style.display = 'none';
    }
  }

  // Groups by person/account (name + bird count), matching the
  // competitor's own "Who's flying" list -- reads the participants map
  // (name + their tracker ids, keyed by org slug) rather than the
  // "organizations" collection, which a visiting fancier can't read for
  // any account but their own. Falls back to just showing the raw tracker
  // count under "the flight organiser" for a group saved before this
  // field existed (no participants map at all yet).
  function renderJoinFlightParticipants(g) {
    const el = document.getElementById('join-flight-participants');
    const participants = g.participants && Object.keys(g.participants).length
      ? g.participants
      : { _unknown: { name: g.organiserName || 'the flight organiser', trackerIds: g.trackerIds || [], isOrganiser: true } };
    // The organiser always shows even with 0 trackers of their own -- not
    // possible today (the Edit form requires at least 1), but kept future-
    // proof for whenever an organiser can run a flight without entering
    // their own birds. Everyone else still needs an actually-entered bird.
    const entries = Object.entries(participants).filter(([slug, p]) => (p.trackerIds || []).length > 0 || slug === g.orgId || slug === '_unknown');
    document.getElementById('join-flight-part-count').textContent = '(' + entries.length + ')';
    const loftsN = grpLoftCount(g);
    document.getElementById('join-flight-lofts-pill').textContent = loftsN + ' Loft' + (loftsN !== 1 ? 's' : '') + ' participating';
    if (entries.length === 0) {
      el.innerHTML = '<div style="color:#8a97a3;font-size:13px;padding:8px 14px;">No trackers entered yet.</div>';
      return;
    }
    const avatarColors = ['#1f4e9c', '#0e2945', '#8b5cf6', '#8a5a34', '#19a974', '#e05a5a'];
    const fmtJoined = (p, isOrganiser) => {
      // No join time is stored per member today, so a real date only shows
      // when the entry carries one (joinedAt); the organiser falls back to
      // when the flight was created. Never invented otherwise.
      const ts = p.joinedAt && p.joinedAt.toMillis ? p.joinedAt.toMillis()
        : (isOrganiser && g.createdAt && g.createdAt.toMillis ? g.createdAt.toMillis() : null);
      return ts ? grpCardDateStr({ startTime: { toMillis: () => ts } }) : '—';
    };
    el.innerHTML = `
      <div class="jf-part-row jf-part-headrow" role="row"><div>#</div><div>Name</div><div>Loft</div><div>Trackers</div><div>Joined</div></div>
    ` + entries.map(([slug, p], i) => {
      const count = (p.trackerIds || []).length;
      const isMe = currentOrg && slug === currentOrg.slug;
      // Derived from slug === g.orgId (or the synthetic "_unknown" fallback
      // entry above, which always IS the organiser by construction) rather
      // than trusting the stored p.isOrganiser flag -- see the matching
      // note in openGroupDetail for why that flag alone isn't reliable.
      const isOrganiser = slug === g.orgId || slug === '_unknown';
      const name = p.name || 'Unknown';
      const loftName = p.homeLoft ? (p.homeLoft.city || p.homeLoft.street || '') : '';
      return `
        <div class="jf-part-row" role="row">
          <div>${i + 1}</div>
          <div class="jf-part-name">${pigeonAvatarHtml({ name, markerColor: avatarColors[i % avatarColors.length] })}<b>${name}</b>
            ${isOrganiser ? '<span class="jf-part-tag">(Organiser)</span>' : ''}${isMe ? '<span class="jf-part-tag">(You)</span>' : ''}${p.withdrawnAt ? '<span class="jf-part-muted">(withdrawn)</span>' : ''}</div>
          <div>${loftName || '—'}</div>
          <div>${count}</div>
          <div class="jf-part-muted">${fmtJoined(p, isOrganiser)}</div>
        </div>
      `;
    }).join('');
  }

  async function submitWithdrawFromFlight(groupId) {
    const ok = await showConfirmModal(
      'Your birds\' track so far stays on the map, marked as withdrawn -- this only stops any new positions from being shared to this flight. This can\'t be undone.',
      'Withdraw from this flight?',
      'Withdraw'
    );
    if (!ok) return;
    try {
      await db.collection('trackerGroups').doc(groupId).update({
        [`participants.${currentOrg.slug}.withdrawnAt`]: firebase.firestore.Timestamp.now()
      });
      showToast('Withdrawn from this flight');
      loadJoinFlightView(groupId);
    } catch (e) {
      showToast('Could not withdraw: ' + e.message);
    }
  }

  async function submitJoinFlight(groupId, flightName) {
    const checked = Array.from(document.querySelectorAll('#join-flight-tracker-checklist input[type="checkbox"]:checked:not(:disabled)')).map(cb => cb.value);
    const statusEl = document.getElementById('join-flight-status');
    if (checked.length === 0) {
      statusEl.textContent = 'Pick at least one tracker to join with.';
      statusEl.style.color = '#c0392b';
      return;
    }
    statusEl.textContent = 'Joining...';
    statusEl.style.color = '#6b7a87';
    try {
      const idToken = await auth.currentUser.getIdToken();
      const resp = await fetch('https://us-central1-flightpathlive-24331.cloudfunctions.net/joinFlight', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
        body: JSON.stringify({ groupId, trackerIds: checked })
      }).then(r => r.json());
      if (!resp.ok) {
        statusEl.textContent = resp.message || 'Could not join this flight.';
        statusEl.style.color = '#c0392b';
        return;
      }
      statusEl.textContent = '';
      showToast('✅ Joined "' + flightName + '"');
      // Refresh the view -- shows the just-added trackers as "already in
      // this flight" and updates the participant list.
      loadJoinFlightView(groupId);
    } catch (e) {
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
    }
  }

  function activateTab(tabName) {
    // Leaving New Track for any other tab -- detach its live detections
    // listener so it doesn't keep running (and consuming reads) in the
    // background for a tracker nobody's looking at anymore.
    if (tabName !== 'new-track' && ntDetectionsUnsubscribe) {
      ntDetectionsUnsubscribe();
      ntDetectionsUnsubscribe = null;
    }
    // Same reasoning -- an ongoing group's detail view can have several
    // live listeners open at once (one per tracker), all left running in
    // the background unless detached when navigating to any other tab.
    if (tabName !== 'group-tracking') grpDetachDetailListeners();

    // The ?joinFlight=<id> link is meant to be bookmarkable while actually
    // ON that page, but leaving it in the URL after navigating to any other
    // tab is stale and wrong -- a refresh on, say, Trackers would otherwise
    // still bounce back into the Join Flight view instead of staying put.
    if (tabName !== 'join-flight' && window.location.search.includes('joinFlight=')) {
      history.replaceState(null, '', window.location.pathname);
    }

    document.querySelectorAll('.db-nav-item, .db-mobile-tab').forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.db-panel').forEach(p => p.classList.remove('active'));
    // New Track has no sidebar/mobile-tab item of its own (only reachable
    // via "View map"), so there's nothing to highlight for it -- every
    // other tab still has one. [data-tab] matches both the sidebar item
    // and the mobile bottom-bar item for the same tab at once.
    document.querySelectorAll(`[data-tab="${tabName}"]`).forEach(el => el.classList.add('active'));
    document.getElementById('db-panel-' + tabName).classList.add('active');
    // All tabs share one scrollable .db-content now -- without this, a new
    // tab opens still scrolled to wherever the PREVIOUS tab was left (e.g.
    // "View map" from partway down the Trackers list would open New Track
    // already scrolled down too, instead of at the top).
    const contentEl = document.querySelector('.db-content');
    if (contentEl) contentEl.scrollTop = 0;


    if (tabName === 'new-track') {
      initNewTrackMap();
      populateNewTrackDropdown();
      setTimeout(() => ntMap && ntMap.invalidateSize(), 50);
      return;
    }

    if (tabName === 'pigeon-pedigree') {
      renderPedigreePage();
      return;
    }

    if (tabName === 'pigeon-details') {
      renderPigeonDetailsPage();
      return;
    }

    if (tabName === 'pigeon-list') {
      return; // no map on this tab -- just the pigeon grid, already rendered
    }

    if (tabName === 'trackers') {
      applyTrackerSearch();
      return;
    }

    if (tabName === 'pairs') {
      // Always land back on the list, not on a previously opened pair.
      closePairDetail();
      renderPairsList();
      return;
    }

    if (tabName === 'seasons') {
      renderSeasonsList();
      return;
    }

    if (tabName === 'trainings') {
      renderTrainingsList();
      return;
    }

    if (tabName === 'feeding') {
      renderFeedingList();
      return;
    }

    if (tabName === 'statistics') {
      renderStatisticsPage();
      return;
    }

    if (tabName === 'home') {
      renderHomeTab();
      return;
    }

    if (tabName === 'group-tracking') {
      // Always land back on the list, not wherever a previous visit's
      // detail view was left -- the detail view's own back button already
      // handles returning to the list within a single visit.
      document.getElementById('grp-detail-view').style.display = 'none';
      document.getElementById('grp-list-view').style.display = 'block';
      applyGroupSearch();
      renderJoinedFlightsList();
      return;
    }

    if (tabName === 'help') {
      applyHelpSearch();
      return;
    }
  }
